// 将超过两个页面使用的组件，提取到一个文件中，并且PDP页面要加载
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();
    // window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    }

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);
  
    if (window.merakiUtils && window.merakiUtils.throttle) {
      window.addEventListener('resize', window.merakiUtils.throttle(this.setHeaderHeight.bind(this)), false);
    }

    this.createObserver();

    this.itemHoverEvent();
  }

  setHeaderHeight() {
    if (this.header) {
      const headerHeight = this.header.getBoundingClientRect().height;
      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
    }
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      document.documentElement.classList.add('mrk-anchor-fixed'); // 固定锚点
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      const headerModalDetails = this.header.querySelector('details-modal details');
      if (headerModalDetails && headerModalDetails.getAttribute('open') == 'true') return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      document.documentElement.classList.add('mrk-anchor-fixed'); // 固定锚点
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    document.documentElement.classList.remove('mrk-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
    document.documentElement.classList.add('mrk-header-sticky');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    document.documentElement.classList.remove('mrk-header-sticky');
    document.documentElement.classList.remove('mrk-anchor-fixed');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach((disclosure) => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    if (this.searchModal) this.searchModal.close(false);
  }

  itemHoverEvent() {
    const navActive = 'active';
    const navNode = this.querySelector('nav.header__inline-menu');
    const menuItemNodes = this.querySelectorAll('.list-menu__item');
    if (!navNode) return;
    
    navNode.addEventListener('mouseover', (e) => {
      navNode.classList.add(navActive);
      const menuItemNode = e.target.closest('.list-menu__item');
      if (menuItemNode) {
        menuItemNodes.forEach((item) => item.classList.remove(navActive));
        menuItemNode.classList.add(navActive);
        this.findParentUp(menuItemNode, '.list-menu__item', navActive);
        if (menuItemNode.tagName.toUpperCase() === 'SUMMARY') {
          const defailsNode = menuItemNode.closest('details');
          const parentItems = defailsNode.querySelectorAll('.header__submenu .list-menu__item');
          parentItems.forEach((item) => item.classList.add(navActive));
        };
        return;
      }
    });
    navNode.addEventListener('mouseleave', (e) => {
      navNode.classList.remove(navActive);
      menuItemNodes.forEach((item) => item.classList.remove(navActive));
    });
  }
  /**
 * 向上一直查找指定选择器的父级
 * @param {HTMLElement} el 当前元素
 * @param {string} selector 目标选择器 .box / #wrap / div
 * @returns {HTMLElement|null}
 */
  findParentUp(el, selector, navActive) {
    let current = el;
    while (current) {
      if (current.matches && current.matches(selector)) {
        current.classList.add(navActive);
        const defailsNode = current.closest('details');
        if (defailsNode) {
          const parentItem = defailsNode.querySelector('summary.list-menu__item');
          if (parentItem) parentItem.classList.add(navActive);
        };
        return current;
      }
      current = current.parentElement;
    }
    return null;
  }
}

customElements.define('sticky-header', StickyHeader);

// details-disclosure.js
class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    // this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
    this.mainDetailsToggle.addEventListener('mouseenter', this.handleMouseenter.bind(this));
    this.mainDetailsToggle.addEventListener('mouseleave', this.handleMouseleave.bind(this));
  }

  handleMouseenter() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.onToggle();
  }

  handleMouseleave() {
    this.mainDetailsToggle.removeAttribute('open');
    this.onToggle();
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

// details-modal.js
class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);

// search-form.js
class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);

// 选择产品变体，切换产品变体的价格、图片等
class MrkProductVariantOptions extends HTMLElement {
  constructor() {
    super();

    this.element = null;

    this.optionClass = '[mrk-option-item]';
    this.is_sale = 'is_sale'; // 是否显示折扣价、原价

    this.loading = false;
    this.sectionId = this.getAttribute('data-section');
    this.productId = this.getAttribute('product-id');
    this.url = this.getAttribute('data-url');
    this.isInitHtml = false;
  }
  connectedCallback() {
    this.init();
  }
  init() {
    this.isInitHtml = this.getAttribute('is-init-html') === 'true';
    this.eventBind();
  }
  eventBind() {
    this.addEventListener('click', (e) => {
      const itemNodes = this.querySelectorAll(this.optionClass);
      const itemNode = e.target.closest(this.optionClass);
      if (itemNode) {
        if (this.isInitHtml) {
          this.getAllVariantData(itemNode);
          return;
        }

        const variantId = itemNode.getAttribute('variant-id');
        itemNodes.forEach((node) => node.removeAttribute('checked'));
        itemNode.setAttribute('checked', '');
        const variantData = this.getVariantData(itemNode, variantId);
        this.setVariant(variantData);
        return;
      }
    })
  }
  setVariant(data) {
    if (data) {
      this.setPrice(data.is_regular, data.price, data.price_regular);
      this.setMedia(data);
      this.setAddCartBtnDisabled(data);
    }
  }
  // 设置按钮是否禁用
  setAddCartBtnDisabled(data) {
    const parentNode = this.closest('[mrk-product-item]');
    if (!parentNode) return;

    const addToCarNode = parentNode.querySelector('[add-cart-btn]');

    if (addToCarNode) {
      if (data.is_sold_out) {
        addToCarNode.setAttribute('disabled', '');
        addToCarNode.classList.add('is_sold_out');
      } else {
        addToCarNode.removeAttribute('disabled');
        addToCarNode.classList.remove('is_sold_out');
      }
    }
  }
  // 设置价格
  setPrice(is_regular, price, price_regular) {
    const parentNode = this.closest('[mrk-product-item]');
    if (!parentNode) return;
    if (is_regular) {
      parentNode.querySelector('[mrk-price_sale_regular]').textContent = price;
      parentNode.querySelector('[mrk-price_sale]').textContent = price_regular;
      parentNode.querySelector('[mrk-price-item]').classList.add(this.is_sale);
    } else {
      parentNode.querySelector('[mrk-price_regular]').textContent = price;
      parentNode.querySelector('[mrk-price-item]').classList.remove(this.is_sale);
    }
  }
  // 设置图片
  setMedia(data) {
    const parentNode = this.closest('[mrk-product-item]');
    const mediaNode = parentNode.querySelector('[mrk-product-image]');
    if (!mediaNode || !data.featured_image) return;
    mediaNode.setAttribute('src', data.featured_image);
  }
  getVariantData(itemNode, optionId) {
    let variantData = itemNode.querySelector(`.mrk-option-variant-json-${optionId}`);
    if (variantData) {
      variantData = JSON.parse(variantData.textContent);
      return variantData;
    }
    return null;
  }

  // 获取变体数据
  getAllVariantData(itemNode) {
    if (!itemNode) return;

    const swatchNodes = this.querySelectorAll('[product-swatch]');
    const currentSwatchParent = itemNode.closest('[product-swatch]');
    const optionIds = [];
    swatchNodes.forEach((swatchNode) => {
      const selectedNode = swatchNode.querySelector('[selected]');
      if (swatchNode !== currentSwatchParent) {
        optionIds.push(selectedNode.getAttribute('option-id'));
      } else {
        optionIds.push(itemNode.getAttribute('option-id'));
      }
    })

    const optionId = optionIds.join(',');
    if (!this.sectionId || !this.url || !optionId) return;
    const params = [];
    params.push(`section_id=${this.sectionId}`);
    if (optionId) {
      params.push(`option_values=${optionId}`);
    }

    const buildRequestUrlWithParams = `${this.url}?${params.join("&")}`;
    if (this.loading) return;
    this.loading = true;

    const mediaGalleryNode = this.closest('media-gallery');
    if (mediaGalleryNode) {
      const addCartBtnNode = mediaGalleryNode.querySelector('[add-cart-btn]');
      if (addCartBtnNode) {
        addCartBtnNode.setAttribute('disabled', '');
      }
    }

    fetch(buildRequestUrlWithParams, {})
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(
          responseText,
          "text/html",
        );
        return html;
      })
      .then((res) => {
        const featuredProductId = `#mrk-featured-product-${this.sectionId}`;
        this.renderAddCartHtml(res, featuredProductId);
        this.renderOptionHtml(res, featuredProductId);
        this.renderPriceHtml(res, featuredProductId);
        this.setSlider(res, featuredProductId);

        if (window.merakiUtils && window.merakiUtils.renderStickyBarHtml) {
          window.merakiUtils.renderStickyBarHtml(this.url, optionId);
        }
      })
      .catch((error) => {
        if (error.name === "AbortError") {
          console.log("Fetch aborted by user");
        } else {
          console.error(error);
        }
      }).finally(() => {
        this.loading = false;
      });
  }

  renderAddCartHtml(html, featuredProductId) {
    const htmlNode = html.querySelector(featuredProductId);
    const featuredProductMainNode = document.querySelector(featuredProductId);
    const productFormId = `#product_form_${this.productId}`;
    if (!featuredProductMainNode || !htmlNode) return;
    const newProductFomNode = htmlNode.querySelector(`${productFormId}`);
    if (newProductFomNode) {
      featuredProductMainNode.querySelector(`${productFormId}`).innerHTML = newProductFomNode.innerHTML;
    };
  }

  renderOptionHtml(html, featuredProductId) {
    const htmlNode = html.querySelector(featuredProductId);
    const featuredProductMainNode = document.querySelector(featuredProductId);
    if (!featuredProductMainNode || !htmlNode) return;
    const newProductFomNode = htmlNode.querySelector('mrk-product-variant-options');
    if (newProductFomNode) {
      featuredProductMainNode.querySelector('mrk-product-variant-options').innerHTML = newProductFomNode.innerHTML;
    };
  }

  renderPriceHtml(html, featuredProductId) {
    const htmlNode = html.querySelector(featuredProductId);
    const featuredProductMainNode = document.querySelector(featuredProductId);
    if (!featuredProductMainNode || !htmlNode) return;
    const newPriceFomNode = htmlNode.querySelector(`#mrk-price-${this.sectionId}`);
    if (newPriceFomNode) {
      featuredProductMainNode.querySelector(`#mrk-price-${this.sectionId}`).innerHTML = newPriceFomNode.innerHTML;
    };
  }

  setSlider(html, featuredProductId) {
    const MediaGallery = html.querySelector('media-gallery');
    if (!MediaGallery) return;
    const mediaId = MediaGallery.getAttribute('data-select-media-id');
    if (!mediaId) return;
    const featuredProductMainNode = document.querySelector(featuredProductId);
    if (!featuredProductMainNode) return;
    const sliderComponentNode = featuredProductMainNode.querySelector('slider-component');
    if (sliderComponentNode) {
      const sliderCurrentNode = sliderComponentNode.querySelector(`li[data-media-id="${this.sectionId}-${mediaId}"]`)
      if (sliderCurrentNode) {
        const index = sliderCurrentNode.dataset.index;
        sliderComponentNode.goToSlide(index);
      }
    };
  }

  disconnectedCallback() {
  }
}
customElements.define('mrk-product-variant-options', MrkProductVariantOptions);

// 加购按钮
class MrkAddCartButton extends HTMLElement {
  constructor() {
    super();

    this.productQuantity = 1;
    this.element = null;
    this.isSelectVariant = true; // 是否可以选择变体，默认可以

    this.loadingClass = '.loading__spinner';

    this.element = this.getElements();

    if (this.element.selectVariant) {
      this.isSelectVariant = this.element.selectVariant === 'false' ? false : true;
    }

    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    this.loadingShowClass = 'hidden';
  }
  connectedCallback() {
    this.init();
  }
  init() {
    this.eventBind();
  }

  getElements() {
    return {
      loadingNode: this.querySelector('.loading__spinner'),
      addCartBtnNode: this.querySelector('[add-cart-btn]'),
      buyNowBtnNode: this.querySelector('[buy-now-btn]'),
      selectVariant: this.getAttribute('select-variant'),
      productItem: this.getAttribute('product-item'),
      productId: this.getAttribute('product-id'),
      variantId: this.getAttribute('variant-id')
    }
  }

  eventBind() {
    this.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (e.target.closest('[add-cart-btn]') === this.element.addCartBtnNode && this.element.addCartBtnNode) {
        if (this.element.addCartBtnNode) {
          const loadingNode = this.element.addCartBtnNode.querySelector(this.loadingClass);
          if (loadingNode) {
            loadingNode.classList.remove(this.loadingShowClass);
          }
          this.element.addCartBtnNode.setAttribute('disabled', '');
  
          // 如果没有变体选择，就需要配置 product-item、select-variant，不然没数据
          if (!this.isSelectVariant) {
            let productItem = this.element.productItem;
            if (productItem) {
              productItem = JSON.parse(productItem);
            } else {
              productItem = []
            }
            this.onSubmitHandler(productItem);
            return;
          }
  
          // 这里是选择变体的情况，可以参考{% render 'mrk-product-variant-options', product: product %}
          const parentNode = this.closest('[mrk-product-item]');
          if (!parentNode) return;
          const variantId = this.getVariantData(parentNode);
          if (variantId) {
            this.onSubmitHandler([{"id": variantId,"quantity": 1}]);
          }
        }
      } else if (e.target.closest('[buy-now-btn]') === this.element.buyNowBtnNode && this.element.buyNowBtnNode) {
        if (this.element.buyNowBtnNode) {
          const loadingNode = this.element.buyNowBtnNode.querySelector(this.loadingClass);
          if (loadingNode) {
            loadingNode.classList.remove(this.loadingShowClass);
          }
          this.element.buyNowBtnNode.setAttribute('disabled', '');
  
          // 如果没有变体选择
          if (!this.isSelectVariant) {
            let productItem = this.element.productItem;
            if (productItem) {
              productItem = JSON.parse(productItem);
            } else {
              productItem = []
            }
            this.onBuyNowHandler(productItem);
            return;
          }
        }
      } else if (e.target.closest('a[href]')) {
        window.location = e.target.href;
      }
    })
  }
  getVariantData(parentNode) {
    let variantData = parentNode.querySelector('mrk-product-variant-options [mrk-option-item][checked]');
    if (variantData) {
      return variantData.getAttribute('variant-id');
    }
    return null;
  }
  getGiftAccessory(isBuyNow = false) {
    const productId = this.element.productId;
    const variantId = this.element.variantId;
    if (!variantId) return [];
    if (window.merakiUtils?.getShopGiftAccessory) {
      const giftAccessoryItem = window.merakiUtils.getShopGiftAccessory({ productId, variantId, isBuyNow, quantity: this.productQuantity });
      if (giftAccessoryItem) {
        return giftAccessoryItem;
      }
    }
    return [];
  }
  onSubmitHandler(products) {
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.headers['Content-Type'] = 'application/json';
    const params = {
      "items": products
    };
    const giftAccessoryItem = this.getGiftAccessory(false, this.productQuantity);
    if (giftAccessoryItem && giftAccessoryItem.length) {
      params.items.unshift(...giftAccessoryItem);
    }
    if (this.cart) {
      this.cart.setActiveElement(document.activeElement);
      params['sections'] = this.cart.getSectionsToRender().map((section) => section.id);
      params['sections_url'] = window.location.pathname;
    }
    // params.items.push({
    //   "id": variantId,
    //   "quantity": 1
    // })
    config.body = JSON.stringify(params);

    fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        // 加购失败，还没有加购失败的提示
        return;
      } else if (!this.cart) {
        window.location = window.routes.cart_url;
        return;
      }
      // 打开加购弹窗
      CartPerformance.measure("add:paint-updated-sections", () => {
        this.cart.renderContents(response);
      });
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      if (this.element.addCartBtnNode) {
        this.element.addCartBtnNode.removeAttribute('disabled');
        const loadingNode = this.element.addCartBtnNode.querySelector(this.loadingClass);
        if (loadingNode) {
          loadingNode.classList.add(this.loadingShowClass);
        }
      }
    });
  }
  /**
   * 立即购买逻辑
   * isBuyNow: true 如果是立即购买，不需要考虑购物车是否存在直接加购产品和赠品
   */
  async onBuyNowHandler(products) {
    try {
      await fetch('/cart/clear.js');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.headers['Content-Type'] = 'application/json';
      const params = {
        "items": []
      };
      const giftAccessoryItem = this.getGiftAccessory(true, this.productQuantity);
      if (giftAccessoryItem && giftAccessoryItem.length) {
        params.items.push(...giftAccessoryItem);
      }
      params.items.push(...products);
      config.body = JSON.stringify(params);

      const response = await fetch(`${routes.cart_add_url}`, config);
      const data = await response.json();
      if (data.status) {
        // 加购失败，还没有加购失败的提示
        throw new Error(data.description);
      }

      window.location.href = '/checkout';
    } catch (error) {
      if (this.element.buyNowBtnNode) {
        this.element.buyNowBtnNode.removeAttribute('disabled');
        const loadingNode = this.element.buyNowBtnNode.querySelector(this.loadingClass);
        if (loadingNode) {
          loadingNode.classList.add(this.loadingShowClass);
        }
      }
      console.error(error);
    }
  }
  disconnectedCallback() {
  }
}
customElements.define('mrk-add-cart-button', MrkAddCartButton);

class MrkAnchor extends HTMLElement {
  constructor() {
    super();

    this.currentClass = 'active';
    this.currentOnlyClass = 'active-only';
    this.hideClass = 'hide-dom';
    this.dataAnchor = 'data-anchor';
    this.strokeDashoffset = 160;

    this.isAnimate = false;

    this.isScroll = false;
    this.scrollTimer = null;

    this.highlightIndex = null;

    this.scrollAnchorFn = window.merakiUtils.throttle(this.initAnchor.bind(this), 20);

    this.element = this.getElements();

    this.init();
  }

  init() {
    this.initAnchor();
    this.bindEvent();
    this.setHeaderClass();
  }

  setHeaderClass() {
    const headerNode = document.querySelector('.shopify-section-group-header-group.section-header');
    if (headerNode) {
      headerNode.classList.add('position-initial');
    }
  }

  getElements() {
    return {
      headerNode: document.querySelector('.section-header'),
      navAnchorNode: this.querySelector('.nav-anchor-wrapper'),
      parentItem: this.querySelector('.anchor-items, [anchor-items]'),
      items: this.querySelectorAll('.anchor-items .item, [item]'),
      levelNavAnchorNode: this.querySelector('.level-nav-anchor-wrapper'),
      levelParentItem: this.querySelector('.level-anchor-items'),
      levelItems: this.querySelectorAll('.level-anchor-items .level-item')
    }
  }

  initAnchor() {
    if (this.isAnimate) return;

    // 持续滚动的时候不改变锚点导航的样式
    this.isScroll = true
    clearTimeout(this.scrollTimer)
    this.scrollTimer = setTimeout(() => {
      this.isScroll = false
      this.setItemHighlight()
      this.setLevelItemHighlight()
      clearTimeout(this.scrollTimer)
      this.scrollTimer = null
    }, 300);

    this.initAnchorOne()
    this.initAnchorTwo()
  }

  initAnchorOne() {
    // 一级锚点
    if (this.element.navAnchorNode) {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      // b. 获取DOM元素相对于视口的顶部位置 + 页面滚动距离 = 元素相对于文档顶部的位置（核心值2）
      const domRect = this.element.navAnchorNode.getBoundingClientRect();
      const domTop = domRect.top + scrollTop - 10;

      // c. 判断：滚动距离 > DOM顶部位置 → 已超过该DOM
      const isScrollOver = scrollTop > domTop;
      // 业务逻辑：根据判断结果做操作（示例）
      if (isScrollOver) {
        if (this.element.headerNode) {
          this.element.headerNode.classList.add(this.hideClass)
        }
      } else {
        if (this.element.headerNode) {
          this.element.headerNode.classList.remove(this.hideClass)
        }
      }

      this.setItemHighlight()
    }
  }

  initAnchorTwo() {
    /**
     * 二级锚点
     * 
     * 1. 最后一个锚点标记的 DOM，已经被滚动距离超过，如果是整个 二级锚点隐藏
     * 2. 第一个锚点标记的 DOM，是否还未进入滚动距离，如果是整个 二级锚点隐藏
     * 3. 那么其它情况就显示
     * 
     * 高亮
     * 1. 用一个变量记录当前锚点已经被滚动超过的锚点位置，默认第一个是 0
     * 2. 如果是 2，那么 1、2 都是高亮
     */
    if (this.element.levelNavAnchorNode) {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const documentHeight = window.innerHeight || document.documentElement.clientHeight
      if (this.element.levelItems && this.element.levelItems.length) {
        const itemLength = this.element.levelItems.length
        const fristSection = document.getElementById(this.element.levelItems[0].getAttribute(this.dataAnchor))
        const lastSection = document.getElementById(this.element.levelItems[itemLength - 1].getAttribute(this.dataAnchor))
        if (fristSection && lastSection) {
          const lastSectionHeight = lastSection.offsetHeight;
          if (scrollTop + documentHeight < fristSection.offsetTop) {
            // 进入滚动距离 或者 被滚动距离超过隐藏
            this.element.levelNavAnchorNode.classList.add(this.hideClass)
          } else if (scrollTop > lastSection.offsetTop + lastSectionHeight) {
            // 进入滚动距离 并且 被滚动距离超过隐藏
            this.element.levelNavAnchorNode.classList.add(this.hideClass)
          } else {
            this.element.levelNavAnchorNode.classList.remove(this.hideClass)
          }
        }
      }

      this.setLevelItemHighlight()
    }
  }

  bindEvent() {
    window.addEventListener('scroll', this.scrollAnchorFn);

    if (this.element.parentItem) {
      this.element.parentItem.addEventListener('click', (e) => {
        const itemNode = e.target.closest('.item,[item]');
        const anchorId = itemNode.getAttribute(this.dataAnchor);
        this.scrollToAnchor({ id: anchorId });
      });
    }

    if (this.element.levelParentItem) {
      this.element.levelParentItem.addEventListener('click', (e) => {
        const itemNode = e.target.closest('.level-item');
        const anchorId = itemNode.getAttribute(this.dataAnchor);
        this.scrollToAnchor({ id: anchorId, isSmooth: true, level: 2, itemNode });
        if (this.element.levelItems && this.element.levelItems.length) {
          this.element.levelItems.forEach((item) => {
            item.classList.remove(this.currentClass);
          })
        }
        itemNode.classList.add(this.currentClass);
      });
    }
  }

  // 滚动到对应位置
  scrollToAnchor({ id, isSmooth = false, level = 1, itemNode = null }) {
    if (this.isAnimate) return;

    window.removeEventListener('scroll', this.scrollAnchorFn);

    const anchorId = document.getElementById(id)
    if (anchorId) {
      this.isAnimate = true;
      if (level === 2 && itemNode) {
        itemNode.classList.add('animation');
      }
      this.manualSmoothScroll(
        anchorId,
        () => {
          this.isAnimate = false;
          if (level === 1) {
            this.initAnchorOne();
          } else if (level === 2) {
            this.initAnchorTwo();
            if (itemNode) {
              itemNode.classList.remove('animation');
            }
          }
          window.addEventListener('scroll', this.scrollAnchorFn);
        },
        isSmooth ? 300 : 10 // 自定义滚动时长
      );
    }
  }

  // 设置一级高亮
  setItemHighlight() {
    try {
      if (this.element.items && this.element.items.length) {
        const offset = 5;
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const documentHeight = window.innerHeight || document.documentElement.clientHeight;

        let highlightIndex = null;

        for (let i = 0; i < this.element.items.length; i++) {
          const item = this.element.items[i];
          const dataAnchor = item.getAttribute(this.dataAnchor);
          const sectionNode = document.getElementById(dataAnchor);

          if (sectionNode) {
            const rect = sectionNode.getBoundingClientRect();

            let sectionOffsetTop = sectionNode.offsetTop;
            if (window.merakiUtils && window.merakiUtils.getDocumentTop) {
              sectionOffsetTop = window.merakiUtils.getDocumentTop(sectionNode);
            }
            if (scrollTop + documentHeight > sectionOffsetTop) {
              // 进入就会高亮
              highlightIndex = i;
              if (rect.top >= -offset && rect.bottom <= documentHeight + offset) {
                break;
              }
            }
          }
        }

        this.element.items.forEach((item, index) => {
          item.classList.remove(this.currentClass)
        })

        // 根据当前二级item调整 scrollLeft
        if (highlightIndex !== null && this.element.parentItem) {
          const currentItemNode = this.element.items[highlightIndex];
          const currentItemWidth = currentItemNode.offsetWidth;
          const currentItemOffsetLeft = currentItemNode.offsetLeft;
          const parentItemWidth = this.element.parentItem.offsetWidth;

          currentItemNode.classList.add(this.currentClass);
          const targetScrollLeft = currentItemOffsetLeft - (parentItemWidth - currentItemWidth) / 2;

          if (!this.isScroll) {
            this.element.parentItem.scrollTo({
              left: targetScrollLeft,
              behavior: 'smooth'
            })
          }
        }
      }
    } catch (error) {
      console.log('setItemHighlight', error);
    }
  }

  // 设置二级高亮
  setLevelItemHighlight() {
    if (this.element.levelItems && this.element.levelItems.length) {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const documentHeight = window.innerHeight || document.documentElement.clientHeight;
      this.element.levelItems.forEach((item, index) => {
        const sectionNode = document.getElementById(item.getAttribute(this.dataAnchor));
        const sectionHeight = sectionNode.clientHeight;
        const svgNode = item.querySelector('.icon .stroke-primary')
        const primaryBorderNode = item.querySelector('.bottom-border.primary')
        item.classList.remove(this.currentOnlyClass);
        item.classList.remove(this.currentClass);

        if (scrollTop + documentHeight - documentHeight / 2.5 > sectionNode.offsetTop) {
          // 进入就会高亮
          this.highlightIndex = index;
          const domRect = sectionNode.getBoundingClientRect();
          const advanceTop = documentHeight / 2.5;
          // const advanceTop = 50;
          if (domRect.top < advanceTop) {
            let ratioRate = (scrollTop + advanceTop - sectionNode.offsetTop) / sectionHeight;
            ratioRate = ratioRate > 1 ? 1 : ratioRate;

            const strokeDashoffset = (1 - ratioRate) * this.strokeDashoffset;
            svgNode.setAttribute('stroke-dashoffset', strokeDashoffset);

            primaryBorderNode.style.width = `${ratioRate * 100}%`
          }
        } else {
          svgNode.setAttribute('stroke-dashoffset', this.strokeDashoffset);
          primaryBorderNode.style.width = '0%';
        }
      })

      // 根据当前二级item调整 scrollLeft
      if (this.highlightIndex !== null && this.element.levelParentItem) {
        const currentItemNode = this.element.levelItems[this.highlightIndex];
        const currentItemWidth = currentItemNode.offsetWidth;
        const currentItemOffsetLeft = currentItemNode.offsetLeft;
        const parentItemWidth = this.element.levelParentItem.offsetWidth;

        currentItemNode.classList.add(this.currentOnlyClass);
        currentItemNode.classList.add(this.currentClass);

        const targetScrollLeft = currentItemOffsetLeft - (parentItemWidth - currentItemWidth) / 2;

        if (!this.isScroll) {
          this.element.levelParentItem.scrollTo({
            left: targetScrollLeft,
            behavior: 'smooth'
          })
        }
      }
    }
  }

  manualSmoothScroll(targetDom, callback, duration = 500) {
    if (!targetDom || typeof callback !== 'function') return;
    const scrollY = window.scrollY || document.documentElement.scrollTop
    // 1. 计算目标位置
    const targetTop = targetDom.getBoundingClientRect().top + scrollY;
    const startTop = scrollY;
    const distance = targetTop - startTop;
    let startTime = null;

    // 2. 滚动动画帧
    function scrollStep(timestamp) {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const easeProgress = progress * (2 - progress); // 缓动公式

      // 执行滚动
      // window.scrollTo(0, startTop + distance * easeProgress);
      window.scrollTo({ 
        top: startTop + distance * easeProgress,
        behavior: 'smooth'
      });

      // 3. 滚动完成判断
      if (progress >= 1) {
        callback(); // 触发回调
        return;
      }

      requestAnimationFrame(scrollStep);
    }

    requestAnimationFrame(scrollStep);
  }
}
customElements.define("mrk-anchor", MrkAnchor);

/**
 * 轮播图插件
 * 支持下面功能
 * 1. 自动播放：autoplay
 * 2. 循环播放：loop
 * 3. 一行显示的个数: itemCountPerRow
 * 4. 轮播项是否居中: slideCenter
 * 5. 播放间隔：autoplayDelay
 * 6. 轮播方向：direction
 * 7. 动画时长：speed
 * 8. 是否无缝播放：seamless
 * 9. 懒加载：lazyLoad
 */
class LMrkCarouusel extends HTMLElement {
  constructor() {
    super();

    this.isInitialized = false; // 是否初始化完成

    this.autoplayTimer = null; // 自动播放定时器
    this.autoplay = false; // 自动播放
    this.autoplayDelay = 5000; // 播放间隔 毫秒
    this.loop = true; // 循环播放
    this.speed = 300; // 动画时长 毫秒
    this.lazyLoad = false; // 懒加载
    this.itemCountPerRow = 0; // 一行显示的个数
    this.direction = 'horizontal'; // 轮播方向 横向 / 纵向 （horizontal / vertical）
    this.slideCenter = false; // 轮播项是否居中
    this.seamless = false; // 是否无缝播放

    this.observer = null;  // 交叉观察器实例，用于后续销毁
    this.ratio = 0.3; // 当前组件距离可视窗口距离是可视窗口的0.5倍就开始初始化。

    this.loopTimer = null; // 动画结束的回调
    this.prevIndex = null; // 上一个轮播项目的索引，默认是null
    this.currentIndex = 0; // 当前轮播项目的位置，默认是0
    this.isAnimate = false; // 是否在执行动画中
    this.dataIndex = 'data-index'; // 当前索引的属性（可以全部都用）
    this.activeClassName = 'active'; // 选择的样式
    this.dotClassName = 'indicator-dot'; // 指示器的类
    this.disableClassName = 'disable'; // 禁用的类

    this.copyFirstLastNum = 0; // copy轮播选项数量，默认0
    this.currentMoveRange = 0; // 记录当前轮播滑动的位置
    this.slideCount = 0; // 轮播项目总个数
    this.slideCountIndex = 0; // 轮播项目总个索引，永远比总个数少一
    this.slideFinalCountIndex = 0; // 排除copy并且插入在最后的轮播项目个数
    this.indicatorsNum = 0; // 指示器数量
    this.boxWidth = 0; // 容器宽度
    this.contentWidth = 0; // 容器内容宽度
    this.itemWidth = 0; // 单个轮播项目宽度
    this.gapWith = 0; // gap 间距

    this.copyIndex = 'copy-index'; // copy dom 的索引
    this.copyMoreNum = 0; // 是否多复制一个，如果是无缝循环需要多加

    this.isVideoPlaying = false; // 视频是否正在播放
    this.currentPlayingVideo = null; // 当前正在播放的视频对象
    this.prevPlayingVideo = null; // 上一个播放的视频对象
    this.videoType = null; // 当前视频播放的视频类型 youtube
    this.videoOptions = ['youtube'];
    /**
     * youtube 需要带有下面属性
     * 1. class：youtube-iframe
     * 2. data-player-id 属性：YouTube 视频id
     * 3. data-block-id: 记录 YouTube 实列的 属性名
     */
    this.youtubePlayers = {}; // YouTube 实例对象

    this.element = null;

    this.slideItemSelector = '.l-carousel-slide,[l-carousel-slide]';

    this.mediaImageSelector = '[media-image]';
    this.mediaVideoSelector = '[media-video]';
  }

  /**
   * 避免多次调用connectedCallback时重复创建观察器（部分浏览器会触发多次）
   * 初始化Intersection Observer，监听自身是否进入视口
   * @returns 
   */
  connectedCallback() {
    if (this.observer) return;
    this.initObserver();
  }

  /**
   * 初始化交叉观察器，监听元素视口状态
   * 配置项：rootMargin提前N px触发（元素即将进入视口时就初始化，无感知）
   * observerOptions
   *    根容器为视口（document.viewport） - root
   *    上下各扩展50px，提前/延后判断 - rootMargin
   *    元素只要有1px进入视口就触发回调 - threshold
   */
  initObserver() {
    const ViewportHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
    const observerOptions = {
      root: null,
      rootMargin: `${ViewportHeight * this.ratio}px 0px`,
      threshold: 0
    };

    /**
     * 1. 创建观察器：回调函数判断是否进入视口
     * 2. 元素进入视口 + 未初始化 → 执行真正的初始化
     * 3. 轮播核心初始化逻辑
     * 4. 初始化完成，取消观察（关键）
     */
    this.observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (entry.isIntersecting) {
        this.init();
        this.observer.unobserve(this);
      }
    }, observerOptions);

    // 开始观察当前自定义元素自身
    this.observer.observe(this);
  }

  init() {
    if (this.isInitialized) return;

    this.element = this.getElements();
    this.initOption();
    this.calcWidth(); // 计算宽度

    if (this.slideCount > 1) {
      this.initCarousel()
    } else {
      this.loadMedia();
    }
  }

  getElements() {
    return {
      containerNode: this.querySelector('.l-carousel-wrapper,[l-carousel-wrapper]'),
      slidesNode: this.querySelector('.l-carousel-slides,[l-carousel-slides]'),
      slideItemNode: this.querySelectorAll(this.slideItemSelector),
      prevNode: this.querySelector('.prev'),
      nextNode: this.querySelector('.next'),
      indicatorsNode: this.querySelector('.carousel-indicators,[carousel-indicators]'),
      switchTabsNode: this.querySelector('[switch-tabs]'),
      switchTabNodes: this.querySelectorAll('[switch-tab]'),
      switchContentNodes: this.querySelectorAll('[switch-content]'),
      mediaTypeBtnNode: this.querySelector('[media-type-btn]'),
      youtubeIframes: this.querySelectorAll('iframe.youtube-iframe'),
      youtubeBtns: this.querySelectorAll('[data-youtube-btn]'),
      dotsNode: null,
      autoplay: this.getAttribute('autoplay'),
      slideCenter: this.getAttribute('slide-center'),
      loop: this.getAttribute('loop'),
      autoplayDelay: this.getAttribute('autoplay-delay'),
      lazyLoad: this.getAttribute('lazy-load'),
      // row: this.getAttribute('row'),
      direction: this.getAttribute('direction'),
      speed: this.getAttribute('speed'),
      seamless: this.getAttribute('seamless')
    }
  }

  // 初始化配置项
  initOption() {
    this.autoplay = this.element.autoplay === 'true';
    this.slideCenter = this.element.slideCenter === 'true';
    this.loop = this.element.loop === 'true';
    this.lazyLoad = this.element.lazyLoad === 'true';
    this.autoplayDelay = this.element.autoplayDelay ? parseFloat(this.element.autoplayDelay) : 5000;
    if (this.element.direction) this.direction = this.element.direction;
    if (this.element.speed) this.speed = parseFloat(this.element.speed);
    this.slideCount = this.element.slideItemNode && this.element.slideItemNode.length;
    this.slideCountIndex = this.slideCount - 1;
    this.seamless = this.element.seamless === 'true';

    if (this.seamless) { // 是否无缝播放
      this.copyMoreNum = 1; // 多复制一个，用于无缝循环
    }
  }

  // 初始化轮播
  initCarousel() {
    this.copyFirstLastNodes(); // 复制首尾节点实现无缝循环
    this.resetTrackPosition(); // 初始化轨道位置
    this.updateTabs();
    this.updateContent();
    this.setItemActive();
    this.createIndicators(); // 自动生成指示器
    this.bindAllEvents(); // 统一绑定所有事件
    this.bindAutoplay(); // 自动播放
    this.loadMedia();
    this.callBtn();
    this.switchContentByMediaType(); // 初始化时根据media-type切换内容

    if (this.element.youtubeIframes && this.element.youtubeIframes.length) {
      this.loadYouTubeAPI();
    }

    this.isInitialized = true;
    this.playPauseVideo();
    this.prevIndex = this.currentIndex;
    this.onInitComplete();
  }

  // 更新轮播
  updateCarousel() {
    this.isAnimate = true; // 开启动画锁
    this.resetTrackPosition();
    this.updateIndicators();
    this.updateTabs();
    this.updateContent();
    this.setItemActive();
    this.loadMedia();
    this.callBtn();
    this.switchContentByMediaType(); // 切换轮播项时，根据 media-type 切换media按钮

    this.onExecuteStart();

    // 动画结束后处理循环，单次监听防止重复触发
    clearTimeout(this.loopTimer);
    this.loopTimer = setTimeout(() => {
      this.animationEndCallback();
      clearTimeout(this.loopTimer);
    }, this.speed)
  }

  // 计算宽度
  calcWidth() {
    if (this.element.slidesNode) {
      this.boxWidth = this.element.slidesNode.offsetWidth;
      this.contentWidth = this.element.slidesNode.scrollWidth;
      const computedBoxStyle = window.getComputedStyle(this.element.slidesNode);
      this.boxWidth = parseFloat(computedBoxStyle.width);
      this.gapWith = parseFloat(computedBoxStyle.gap) || 0;
    }
    if (this.element.slideItemNode && this.element.slideItemNode.length) {
      this.slideCount = this.element.slideItemNode && this.element.slideItemNode.length;
      this.slideCountIndex = this.slideCount - 1;
      const computedStyle = window.getComputedStyle(this.element.slideItemNode[0]);
      this.itemWidth = parseFloat(computedStyle.width);
      if (this.slideCenter) {
        // 计算容器一屏可以展示的轮播项目数量
        this.itemCountPerRow = Math.floor(this.boxWidth / this.itemWidth);
        if (this.itemCountPerRow > this.slideCount) {
          this.itemCountPerRow = this.slideCount;
        } else {
          if (this.seamless) { // 是否无缝播放
            this.itemCountPerRow += this.copyMoreNum; // 多复制一个，用于无缝循环
          }
        }

        this.indicatorsNum = this.slideCount;
      } else {
        // 计算容器一屏可以展示的轮播项目数量
        const itemCountPerRow = Math.floor(this.boxWidth / this.itemWidth);
        this.indicatorsNum = this.slideCount - itemCountPerRow + 1;
      }
    }
  }

  // 重置轨道位置
  resetTrackPosition() {
    // 如果是垂直滚动
    if (this.direction === 'vertical') {
      this.verticalPosition();
      return
    }

    let slidesOffsetX = (this.itemWidth + this.gapWith) * this.currentIndex;
    if (!this.slideCenter) {
      const contentWidth = this.contentWidth - this.boxWidth;
      if (slidesOffsetX > contentWidth) slidesOffsetX = contentWidth;
    }

    // 轮播项是否居中
    if (this.slideCenter) {
      slidesOffsetX = slidesOffsetX - (this.boxWidth - this.itemWidth) / 2;
    }

    this.currentMoveRange = slidesOffsetX;
    this.element.slidesNode.style.transition = `all ${this.speed / 1000}s`;
    this.element.slidesNode.style.transform = `translateX(${-slidesOffsetX}px)`;
    void this.element.slidesNode.offsetWidth; // 强制重绘，防止过渡失效
  }

  // 垂直滚动
  verticalPosition() {
    let slidesOffsetY = 0;
    if (this.element.slideItemNode && this.element.slideItemNode.length) {
      for (let i = 0; i < (this.element.slideItemNode.length - this.copyFirstLastNum); i++) {
        if (i === this.currentIndex) {
          break;
        }
        const slideItem = this.element.slideItemNode[i];
        const itemHeight = slideItem.offsetHeight;
        slidesOffsetY += itemHeight + this.gapWith;
      }
    }
    this.element.slidesNode.style.transition = `all ${this.speed / 1000}s`;
    this.element.slidesNode.style.transform = `translateY(${-slidesOffsetY}px)`;
    void this.element.slidesNode.offsetWidth; // 强制重绘，防止过渡失效
  }

  // 设置 高亮
  setItemActive() {
    if (this.element.slideItemNode && this.element.slideItemNode.length) {
      this.element.slideItemNode.forEach(item => {
        item.classList.remove(this.activeClassName);
      })

      // 如果 slider 居中，且当前索引超出范围，同时设置第一个项目也为高亮，为了无缝切换效果一样
      if (this.slideCenter && this.seamless) {
        if (this.currentIndex >= this.slideFinalCountIndex + this.copyMoreNum) {
          // 下一个按钮，如果是最后一个，继续给slider动画执行完，在切换为第一个索引的 slider
          const firstItemIndex = this.copyFirstLastNum; // 真正的索引值
          const firstItemNode = this.element.slideItemNode[firstItemIndex];
          firstItemNode.classList.add(this.activeClassName);
        } else if (this.currentIndex <= this.copyFirstLastNum - this.copyMoreNum) {
          // 上一个按钮，如果是第一个，继续给slider动画执行完，在切换为最后一个索引的 slider
          const lastItemIndex = this.slideFinalCountIndex; // 真正的索引值
          const lastItemNode = this.element.slideItemNode[lastItemIndex];
          lastItemNode.classList.add(this.activeClassName);
        }
      }

      const itemNode = this.element.slideItemNode[this.currentIndex];
      itemNode.classList.add(this.activeClassName);
    }
  }

  // 复制首尾节点：无缝循环核心
  copyFirstLastNodes() {
    const copyClass = 'copy';
    let copyIndex = 0;

    for (let i = 0; i < this.itemCountPerRow; i++) {
      const lastNode = this.element.slideItemNode[this.slideCountIndex - i].cloneNode(true);
      if (lastNode) {
        lastNode.setAttribute('copy-index', copyIndex);
        copyIndex++;
        lastNode.classList.add(copyClass);
        this.element.slidesNode.insertBefore(lastNode, this.element.slidesNode.firstChild);
      }

      const firstNode = this.element.slideItemNode[i].cloneNode(true);
      if (firstNode) {
        firstNode.setAttribute('copy-index', copyIndex);
        copyIndex++;
        firstNode.classList.add(copyClass);
        this.element.slidesNode.appendChild(firstNode);
      }
    }

    this.copyFirstLastNum = this.itemCountPerRow;
    this.currentIndex = this.copyFirstLastNum;
    this.slideFinalCountIndex = this.slideCount + this.copyFirstLastNum - 1;

    this.element.slideItemNode = this.querySelectorAll(this.slideItemSelector);
  }

  // 绑定所有事件
  bindAllEvents() {
    if (this.element.prevNode) {
      this.element.prevNode.addEventListener('click', () => {
        if (this.isAnimate) return;
        if (!this.loop && this.currentIndex === this.copyFirstLastNum) return; // 不可循环

        if (this.slideCenter) {
          if (this.currentIndex === this.copyFirstLastNum - this.copyMoreNum) {
            this.currentIndex = this.slideFinalCountIndex;
          } else {
            this.currentIndex--;
          }
        } else {
          if (this.currentIndex === this.copyFirstLastNum) {
            this.currentIndex = this.indicatorsNum - 1;
          } else {
            this.currentIndex--;
          }
        }
        this.updateCarousel();
      });
    }

    if (this.element.nextNode) {
      this.element.nextNode.addEventListener('click', () => {
        if (this.isAnimate) return;

        if (this.slideCenter) { // 高亮 slide 居中的情况
          if (!this.loop && this.currentIndex === this.slideFinalCountIndex) return; // 不可循环
          if (this.currentIndex === this.slideFinalCountIndex + this.copyMoreNum) {
            this.currentIndex = this.copyFirstLastNum;
          } else {
            this.currentIndex++;
          }
        } else {
          if (!this.loop && this.currentIndex === this.indicatorsNum - 1) return; // 不可循环
          if (this.currentIndex === this.indicatorsNum - 1) {
            this.currentIndex = this.copyFirstLastNum;
          } else {
            this.currentIndex++;
          }
        }

        this.updateCarousel();
      });
    }

    // tab 事件
    if (this.element.switchTabsNode) {
      this.element.switchTabsNode.addEventListener('click', (e) => {
        if (this.isAnimate) return;
        const currentTab = e.target.closest('[switch-tab]');
        if (!currentTab) return;
        const tabIndex = Array.from(this.element.switchTabNodes).indexOf(currentTab);
        this.currentIndex = this.copyFirstLastNum + tabIndex;
        this.updateCarousel();
      });
    }

    // 移动端滑动事件
    let startX = 0, moveX = 0, isMoving = false, startY = 0;
    this.element.slidesNode.addEventListener('touchstart', (e) => {
      if (this.isAnimate) return;
      isMoving = true;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    });

    this.element.slidesNode.addEventListener('touchmove', (e) => {
      if (!isMoving || this.isAnimate) return;
      moveX = e.touches[0].clientX - startX;
      const deltaY = e.touches[0].clientY - startY;
      if (Math.abs(moveX) > Math.abs(deltaY)) {
        this.element.slidesNode.style.transition = 'none';
        this.element.slidesNode.style.transform = `translateX(${-(this.currentMoveRange - moveX)}px)`;
        e.preventDefault();
      }
    }, { passive: false });

    this.element.slidesNode.addEventListener('touchend', () => {
      touchEndcallback.apply(this)
    });

    this.element.slidesNode.addEventListener('touchcancel', () => {
      touchEndcallback.apply(this)
    });

    window.addEventListener('resize', () => {
      if (this.isAnimate) return;
      this.calcWidth();
      this.resetTrackPosition();
    });

    // 手势滑动结束回调
    function touchEndcallback() {
      if (!isMoving || this.isAnimate) return;
      isMoving = false;
      const threshold = this.boxWidth * 0.2; // 滑动阈值
      if (moveX > threshold) {
        if (this.loop || this.currentIndex !== this.copyFirstLastNum) {
          if (this.slideCenter) {
            if (this.currentIndex === this.copyFirstLastNum - this.copyMoreNum) {
              this.currentIndex = this.slideFinalCountIndex;
            } else {
              this.currentIndex--;
            }
          } else {
            if (this.currentIndex === this.copyFirstLastNum) {
              this.currentIndex = this.indicatorsNum - 1;
            } else {
              this.currentIndex--;
            }
          }
        }
      } else if (moveX < -threshold) {
        if (this.loop || this.currentIndex !== this.slideFinalCountIndex) {
          if (this.slideCenter) {
            if (this.currentIndex === this.slideFinalCountIndex + this.copyMoreNum) {
              this.currentIndex = this.copyFirstLastNum;
            } else {
              this.currentIndex++;
            }
          } else {
            if (this.currentIndex === this.indicatorsNum - 1) {
              this.currentIndex = this.copyFirstLastNum;
            } else {
              this.currentIndex++;
            }
          }
        }
      };
      this.updateCarousel();
      startX = 0;
      moveX = 0;
    }

    this.addEventListener('click', (e) => {
      // 隐藏的播放按钮
      const target = e.target.closest('[data-youtube-btn]');
      if (target) {
        const parentSlideNode = target.closest('.l-carousel-slide');
        const iframeNode = parentSlideNode.querySelector('iframe.youtube-iframe');
        if (iframeNode) {
          const blockId = iframeNode.dataset.blockId; // 获取集合中保存的标识
          const player = this.youtubePlayers[blockId]; // 获取 YouTube 实例
          if (player) {
            let timer = setTimeout(() => {
              player.playVideo();
              clearTimeout(timer);
              timer = null;
            }, 100);
          }
        }
        return;
      }

      // 切换media按钮，并切换轮播图
      if (this.element.mediaTypeBtnNode) {
        const mediaImage = e.target.closest(this.mediaImageSelector);
        const mediaVideo = e.target.closest(this.mediaVideoSelector);
        if (mediaVideo) {
          const itemImgIndex =  Array.from(this.element.slideItemNode).findIndex((item) => item.dataset.mediaType === 'video');
          this.customSwitch(itemImgIndex);
        } else if (mediaImage) {
          const itemVideoIndex = Array.from(this.element.slideItemNode).findIndex((item) => item.dataset.mediaType === 'image');
          this.customSwitch(itemVideoIndex);
        }
        return;
      }
    })
  }

  // 设置是否正在播放标识
  setIsVideoPlaying(iframeId, isPlaying) {
    const iframeNode = this.querySelector(`iframe[data-block-id="${iframeId}"]`);
    if (iframeNode) {
      const parentSlideNode = iframeNode.closest('.l-carousel-slide');
      if (isPlaying) {
        parentSlideNode.setAttribute('data-playing', '');
      } else {
        parentSlideNode.removeAttribute('data-playing');
      }
    }
  }

  // 自动生成指示器
  createIndicators() {
    if (this.element.indicatorsNode) {
      this.element.indicatorsNode.innerHTML = '';
      for (let i = 0; i < this.indicatorsNum; i++) {
        const dot = document.createElement('span');
        dot.setAttribute(this.dataIndex, i);
        dot.className = `${this.dotClassName} ${i === 0 ? this.activeClassName : ''}`;
        this.element.indicatorsNode.appendChild(dot);
      }

      this.element.dotsNode = this.querySelectorAll(`.${this.dotClassName}`);

      this.element.indicatorsNode.addEventListener('click', (e) => {
        if (this.isAnimate) return;
        const dotNode = e.target.closest(`.${this.dotClassName}`)
        if (dotNode) {
          const index = dotNode.getAttribute(this.dataIndex)
          this.currentIndex = parseFloat(index) + this.copyFirstLastNum;
          this.updateCarousel();
        }
      });
    }
  }

  // 更新指示器激活状态
  updateIndicators() {
    if (this.element.dotsNode && this.element.dotsNode.length) {
      this.element.dotsNode.forEach((dot, index) => {
        dot.className = `${this.dotClassName} ${index + this.copyFirstLastNum === this.currentIndex ? this.activeClassName : ''}`;
      });
    }
  }

  // 更新tabs按钮激活状态
  updateTabs() {
    if (this.element.switchTabNodes && this.element.switchTabsNode) {
      this.element.switchTabNodes.forEach(tab => {
        tab.classList.remove(this.activeClassName);
      })
      const currentTab = this.element.switchTabNodes[this.currentIndex - this.copyFirstLastNum];
      if (currentTab) {
        currentTab.classList.add(this.activeClassName);
      }
    }
  }

  // 更新内容激活状态
  updateContent() {
    if (this.element.switchContentNodes) {
      this.element.switchContentNodes.forEach(content => {
        content.classList.remove(this.activeClassName);
      })
      let currentContent = this.element.switchContentNodes[this.currentIndex - this.copyFirstLastNum];

      if (this.slideCenter && this.seamless) { // 居中且无缝播放
        if (this.currentIndex >= this.slideFinalCountIndex + this.copyMoreNum) {
          currentContent = this.element.switchContentNodes[0];
        } else if (this.currentIndex <= this.copyFirstLastNum - this.copyMoreNum) {
          currentContent = this.element.switchContentNodes[this.element.switchContentNodes.length - 1];
        }
      }

      if (currentContent) {
        currentContent.classList.add(this.activeClassName);
      }
    }
  }

  // 轮播自动播放
  bindAutoplay() {
    if (!this.autoplayTimer && this.autoplay) {
      this.autoplayTimer = setInterval(this.startInterval.bind(this), this.autoplayDelay);
    }
  }

  // 启动自动轮播
  startInterval() {
    if (this.slideCenter) { // 高亮 slide 居中的情况
      if (this.currentIndex === this.slideFinalCountIndex + this.copyMoreNum) {
        this.currentIndex = this.copyFirstLastNum;
      } else {
        this.currentIndex++;
      }
      this.updateCarousel();
      if (!this.loop && this.currentIndex === this.slideFinalCountIndex) {
        this.pauseInterval();
      }
    } else {
      if (this.currentIndex === this.indicatorsNum - 1) {
        this.currentIndex = this.copyFirstLastNum;
      } else {
        this.currentIndex++;
      }
      this.updateCarousel();
      if (!this.loop && this.currentIndex === this.indicatorsNum - 1) {
        this.pauseInterval();
      }
    }

    // if (this.currentIndex === this.slideFinalCountIndex) {
    //   this.currentIndex = this.copyFirstLastNum;
    // } else {
    //   this.currentIndex++;
    // }
    // this.updateCarousel();
    // if (!this.loop && this.currentIndex === this.slideFinalCountIndex) {
    //   this.pauseInterval();
    // }
  }

  // 暂停自动轮播
  pauseInterval() {
    clearInterval(this.autoplayTimer);
    this.autoplayTimer = null;
  }

  // 懒加载
  loadMedia() {
    if (this.lazyLoad) {
      const startIndex = this.currentIndex - this.copyFirstLastNum;
      const endIndex = this.currentIndex + this.copyFirstLastNum + 1;
      for (let i = startIndex; i <= endIndex; i++) {
        const imgEl = this.element.slideItemNode[i]?.querySelectorAll('img.lazy');
        const iframeEl = this.element.slideItemNode[i]?.querySelectorAll('iframe.lazy');
        const videoEl = this.element.slideItemNode[i]?.querySelectorAll('video.lazy');
        if (imgEl && imgEl.length > 0) {
          imgEl.forEach((img) => {
            this.loadImage(img);
          })
        }
        if (iframeEl && iframeEl.length > 0) {
          if (this.isInitialized === true) {
            iframeEl.forEach((el) => {
              this.loadIframe(el, (iframeNode) => {
                if (this.isInitialized === true) {
                  this.setYtPlayer(iframeNode);
                }
              });
            })
          } else {
            iframeEl.forEach((el) => {
              this.loadIframe(el);
            })
          }
        }
        if (videoEl && videoEl.length > 0) {
          videoEl.forEach((video) => {
            if (!this.isHidden(video)) {
              this.loadVideo(video);
            }
          })
        }
      }
    }
  }

  loadImage(imgNode) {
    const medaiSrc = imgNode.getAttribute('data-src');
    if (medaiSrc) {
      imgNode.src = medaiSrc;
      const pictureNode = imgNode.closest('picture')
      if (pictureNode) {
        const sources = pictureNode.querySelectorAll('source')
        if (sources && sources.length > 0) {
          sources.forEach((source) => {
            const srcset = source.getAttribute('data-srcset');
            if (srcset) {
              source.srcset = source.getAttribute('data-srcset');
              source.removeAttribute('data-srcset');
            }
          })
        }
      }
      const srcset = imgNode.getAttribute('data-srcset');
      if (srcset) {
        imgNode.srcset = imgNode.getAttribute('data-srcset');
        imgNode.removeAttribute('data-srcset');
      }
      imgNode.removeAttribute('data-src');
      imgNode.classList.remove('lazy');
    }
  }
  loadIframe(iframeNode, load = () => { }) {
    const medaiSrc = iframeNode.getAttribute('data-src');
    if (medaiSrc) {
      iframeNode.onload = function () {
        load(iframeNode);
      };
      iframeNode.src = medaiSrc;
      iframeNode.removeAttribute('data-src');
      iframeNode.classList.remove('lazy');
    }
  }
  // 加载单个视频
  loadVideo(videoDom) {
    const isNone = window.getComputedStyle(videoDom).display === 'none';
    if (!isNone) {
      videoDom.poster = videoDom.getAttribute('data-poster');
      const sourceDoms = videoDom.querySelectorAll('source')
      if (sourceDoms && sourceDoms.length > 0) {
        sourceDoms.forEach((sourceDom) => {
          sourceDom.src = sourceDom.getAttribute('data-src');
        })
        videoDom.load();
      }
      videoDom.removeAttribute('data-poster');
      videoDom.classList.remove('lazy');
    }
  }

  // 视频播放或暂停
  playPauseVideo() {
    if (this.prevIndex !== null) {
      const prevVideoEl = this.element.slideItemNode[this.prevIndex]?.querySelectorAll('video:not(.lazy)');
      if (prevVideoEl && prevVideoEl.length > 0) {
        prevVideoEl.forEach((video) => {
          video.pause();
        })
      }
    }

    const currentVideoEl = this.element.slideItemNode[this.currentIndex]?.querySelectorAll('video:not(.lazy)');
    if (currentVideoEl && currentVideoEl.length > 0) {
      currentVideoEl.forEach((video) => {
        video.play();
      })
    }
  }

  isHidden(el) {
    if (!el || el.nodeType !== 1) return false;
    if (window.getComputedStyle(el).display === 'none' || window.getComputedStyle(el).visibility === 'hidden' || parseFloat(window.getComputedStyle(el).opacity) === 0) return true;
    return el.parentNode ? this.isHidden(el.parentNode) : false;
  }

  // 轮播动画结束
  animationEndCallback() {
    this.isAnimate = false; // 关闭动画锁
    this.updateSlideCenterAndSeamlessLoop();
    this.pauseVideo();
    this.playPauseVideo();
    this.onExecuteEnd();

    this.prevIndex = this.currentIndex;
  }

  // 判断 slide 是否居中，同时无缝轮播，需要设置无缝效果
  updateSlideCenterAndSeamlessLoop() {
    // 高亮 slide 居中的情况
    if (this.slideCenter && this.seamless) {
      if (this.currentIndex >= this.slideFinalCountIndex + this.copyMoreNum) {
        this.currentIndex = this.copyFirstLastNum;
      } else if (this.currentIndex <= this.copyFirstLastNum - this.copyMoreNum) {
        this.currentIndex = this.slideFinalCountIndex;
      }
      let slidesOffsetX = (this.itemWidth + this.gapWith) * this.currentIndex;
      slidesOffsetX = slidesOffsetX - (this.boxWidth - this.itemWidth) / 2;
      this.currentMoveRange = slidesOffsetX;
      this.element.slidesNode.style.transition = `all 0s`;
      this.element.slidesNode.style.transform = `translateX(${-slidesOffsetX}px)`;
      void this.element.slidesNode.offsetWidth; // 强制重绘，防止过渡失效
      this.setItemActive();
      this.updateIndicators();
    }
  }

  // 判断按钮是否可以点击
  callBtn() {
    if (!this.loop) {
      if (this.currentIndex === this.copyFirstLastNum) {
        if (this.indicatorsNum === 1) {
          this.setBtnStaus('all');
        } else {
          this.setBtnStaus('prev');
        }
      } else if (this.slideCenter && this.currentIndex === this.slideFinalCountIndex) {
        this.setBtnStaus('next');
      } else if (!this.slideCenter && this.currentIndex === this.indicatorsNum - 1) {
        this.setBtnStaus('next');
      } else {
        this.setBtnStaus();
      }
    }
  }

  // 设置按钮状态
  setBtnStaus(type) {
    switch (type) {
      case 'prev':
        if (this.element.prevNode) {
          this.element.prevNode.classList.add(this.disableClassName);
        }
        if (this.element.nextNode) {
          this.element.nextNode.classList.remove(this.disableClassName);
        }
        break;
      case 'next':
        if (this.element.nextNode) {
          this.element.nextNode.classList.add(this.disableClassName);
        }
        if (this.element.prevNode) {
          this.element.prevNode.classList.remove(this.disableClassName);
        }
        break;
      case 'all':
        if (this.element.nextNode) {
          this.element.nextNode.classList.add(this.disableClassName);
        }
        if (this.element.prevNode) {
          this.element.prevNode.classList.add(this.disableClassName);
        }
        break;
      default:
        if (this.element.prevNode) {
          this.element.prevNode.classList.remove(this.disableClassName);
        }
        if (this.element.nextNode) {
          this.element.nextNode.classList.remove(this.disableClassName);
        }
        break;
    }
  }

  // 初始化 YouTube Api
  loadYouTubeAPI() {
    if (document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
      this.bindYouTubeEvents();
      return;
    }
    const script = document.createElement('script');
    script.src = 'https://www.youtube.com/iframe_api';
    script.type = 'text/javascript';
    script.async = true;
    script.onload = () => {
      window.onYouTubeIframeAPIReady = () => {
        this.bindYouTubeEvents();
      };
    };
    script.onerror = () => { };
    document.body.appendChild(script);
  }

  // 批量绑定YouTube的视频事件
  bindYouTubeEvents() {
    // 存储播放器实例：key=自定义标识，value=播放器实例
    this.youtubePlayers = {};
    if (!window.YT) return;
    this.element.youtubeIframes.forEach((iframeNode) => {
      if (iframeNode.getAttribute('src')) {
        this.setYtPlayer(iframeNode);
      }
    })
  }

  // 初始化播放器实例，然后储存
  setYtPlayer(iframeNode) {
    if (iframeNode && window.YT) {
      const playerId = iframeNode.dataset.playerId; // 获取自定义标识
      let blockId = iframeNode.dataset.blockId; // 获取自定义标识
      if (playerId && blockId) {
        const slideCopyIndex = iframeNode.closest('.l-carousel-slide').getAttribute(this.copyIndex);
        if (slideCopyIndex) {
          blockId += `__${slideCopyIndex}`;
        }
        // 初始化播放器实例（绑定到现有 iframe）
        const player = new YT.Player(iframeNode, {
          events: {
            'onStateChange': (event) => {
              this.handlePlayState(event, blockId);
            },
            'onReady': () => {
              // console.log(`播放器 ${blockId} 就绪`)
            }
          }
        });
        this.youtubePlayers[blockId] = player;
      }
    }
  }

  // 4. 统一处理播放状态（核心：判断点击播放）
  handlePlayState(event, blockId) {
    const state = event.data;
    const isYoutubeBtns = this.element.youtubeBtns && this.element.youtubeBtns.length;
    switch (state) {
      case 1:
        // console.log(`【${blockId}】视频被点击播放！`);
        if (this.currentPlayingVideo && this.currentPlayingVideo !== blockId) {
          this.prevPlayingVideo = this.currentPlayingVideo;
          this.pauseVideo(this.prevPlayingVideo);
        }
        this.videoType = this.videoOptions[0];
        this.currentPlayingVideo = blockId;
        if (!this.isVideoPlaying) {
          this.isVideoPlaying = true;
        }
        this.pauseInterval();
        if (isYoutubeBtns) this.setIsVideoPlaying(blockId, true);
        break;
      case 2:
        // console.log(`【${blockId}】视频被暂停`, this.currentPlayingVideo, blockId);
        if (this.currentPlayingVideo === blockId) {
          this.currentPlayingVideo = null;
          if (this.isVideoPlaying) {
            this.isVideoPlaying = false;
          }
          this.bindAutoplay();
        }
        if (isYoutubeBtns) this.setIsVideoPlaying(blockId, false);
        break;
      case 0:
        // console.log(`【${blockId}】视频播放结束`, this.currentPlayingVideo, blockId);
        if (this.currentPlayingVideo === blockId) {
          this.currentPlayingVideo = null;
          if (this.isVideoPlaying) {
            this.isVideoPlaying = false;
          }
          this.bindAutoplay();
        }
        if (isYoutubeBtns) this.setIsVideoPlaying(blockId, false);
        break;
    }
  }

  // 切换轮播后暂停播放视频
  pauseVideo(videoId = this.currentPlayingVideo) {
    if (this.isVideoPlaying) {
      this.isVideoPlaying = false;
      switch (this.videoType) {
        case this.videoOptions[0]:
          if (this.youtubePlayers && this.youtubePlayers[videoId]) {
            if (this.youtubePlayers[videoId].pauseVideo) {
              this.youtubePlayers[videoId].pauseVideo();
            }
          }
          break;
      }
    }
  }

  // 自定义切换轮播项
  customSwitch(index) {
    if (this.isAnimate) return;
    this.currentIndex = parseFloat(index) + this.copyFirstLastNum;
    if (this.isInitialized) {
      this.updateCarousel();
    } else {
      this.init();
      this.currentIndex = parseFloat(index) + this.copyFirstLastNum;
      this.updateCarousel();
    }
  }

  // 切换轮播项时，根据 media-type 切换media按钮
  switchContentByMediaType() {
    if (!this.element.mediaTypeBtnNode) return;
    const itemNode = this.element.slideItemNode[this.currentIndex];
    const mediaType = itemNode.dataset.mediaType;
    if (this.currentMediaType && mediaType === this.currentMediaType) return;
    this.currentMediaType = mediaType;
    if (mediaType === 'image') {
      const imageBtnNode = this.element.mediaTypeBtnNode.querySelector(this.mediaImageSelector);
      const videoBtnNode = this.element.mediaTypeBtnNode.querySelector(this.mediaVideoSelector);
      if (imageBtnNode) imageBtnNode.classList.add('mrk-none');
      if (videoBtnNode) videoBtnNode.classList.remove('mrk-none');
    } else if (mediaType === 'video') {
      const imageBtnNode = this.element.mediaTypeBtnNode.querySelector(this.mediaImageSelector);
      const videoBtnNode = this.element.mediaTypeBtnNode.querySelector(this.mediaVideoSelector);
      if (imageBtnNode) imageBtnNode.classList.remove('mrk-none');
      if (videoBtnNode) videoBtnNode.classList.add('mrk-none'); 
    }
  }

  // 初始化完成
  onInitComplete() {
    // console.log('****** 初始化完成', this.constructor)
  }

  // 轮播开始执行
  onExecuteStart() {
    // console.log('****** 轮播开始执行', this.constructor)
  }

  // 轮播执行完成
  onExecuteEnd() {
    // console.log('****** 轮播执行完成', this.constructor)
  }
}
customElements.define("l-mrk-carousel", LMrkCarouusel);

/*
  mrk-carousel-drag 轮播组件
 * 支持下面功能
 * 自动播放：autoplay
 * 循环播放：loop
 * 播放间隔：autoplayDelay
 * 动画时长：speed
 * 无缝轮播：infinite
*/
class MrkCarouselDrag extends HTMLElement {
  constructor() {
    super();

    this.isInitialized = false; // 是否初始化完成

    this.autoplayTimer = null; // 自动播放定时器
    this.autoplay = false; // 自动播放
    this.autoplayDelay = 5000; // 播放间隔 毫秒
    this.loop = true; // 循环播放
    this.speed = 300; // 动画时长 毫秒

    this.infinite = false; // 无缝走马灯
    this.startTimeInfinite = 0; // 走马灯开始时间戳

    this.itemCountPerRow = 0; // 一行显示的个数
    this.dragMove = true; // 是否可以拖拽滑动
    this.isDragging = false; // 是否正在拖拽

    // 是否满足自动播放的条件
    this.isAutoplay = true;
    
    this.observer = null;  // 交叉观察器实例，用于后续销毁
    this.ratio = 0.3; // 当前组件距离可视窗口距离是可视窗口的0.5倍就开始初始化。

    this.loopTimer = null; // 动画结束的定时器
    this.currentIndex = 0; // 当前轮播项目的位置，默认是0
    this.startIndex = 0; // 轮播开始索引，默认是0
    this.isAnimate = false; // 是否在执行动画中
    this.dataIndex = 'data-index'; // 当前索引的属性（可以全部都用）
    this.activeClassName = 'active'; // 选择的样式
    this.dotClassName = 'indicator-dot'; // 指示器的类
    this.disableClassName = 'disable'; // 禁用的类

    this.currentMoveRange = 0; // 记录当前轮播滑动的位置（单位：px）/ 走马灯移动到的下一个位置
    this.slideCount = 0; // 轮播项目总个数
    this.slideCountIndex = 0; // 轮播项目总个索引，永远比总个数少一
    this.boxWidth = 0; // 容器宽度
    this.itemWidth = 0; // 单个轮播项目宽度
    this.slideOffsetWidths = 0; // 轮播项目总宽度（包含间距）
    this.gapWith = 0; // gap 间距

    this.element = null;
  }

  /**
   * 避免多次调用connectedCallback时重复创建观察器（部分浏览器会触发多次）
   * 初始化Intersection Observer，监听自身是否进入视口
   * @returns 
   */
  connectedCallback() {
    if (this.observer) return;
    this.initObserver();
  }

  /**
   * 初始化交叉观察器，监听元素视口状态
   * 配置项：rootMargin提前N px触发（元素即将进入视口时就初始化，无感知）
   * observerOptions
   *    根容器为视口（document.viewport） - root
   *    上下各扩展50px，提前/延后判断 - rootMargin
   *    元素只要有1px进入视口就触发回调 - threshold
   */
  initObserver() {
    const ViewportHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
    const observerOptions = {
      root: null,
      rootMargin: `${ViewportHeight * this.ratio}px 0px`,
      threshold: 0
    };

    /**
     * 1. 创建观察器：回调函数判断是否进入视口
     * 2. 元素进入视口 + 未初始化 → 执行真正的初始化
     * 3. 轮播核心初始化逻辑
     * 4. 初始化完成，取消观察（关键）
     */
    this.observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (entry.isIntersecting) {
        this.init();
        this.observer.unobserve(this);
      }
    }, observerOptions);

    // 开始观察当前自定义元素自身
    this.observer.observe(this);
  }

  init() {
    if (this.isInitialized) return;

    this.element = this.getElements();
    this.initOption();
    this.calcWidth(); // 计算各个DOM的宽度等数据
    if (this.slideCount > 1) {
      this.initCarousel()
    }
  }

  getElements() {
    return {
      containerNode: this.querySelector('.l-carousel-wrapper'),
      carouselContentNode: this.querySelector('.l-carousel-content'),
      slidesNode: this.querySelector('.l-carousel-slides'),
      slideItemNode: this.querySelectorAll('.l-carousel-slide'),
      prevNode: this.querySelector('.prev'),
      nextNode: this.querySelector('.next'),
      indicatorsNode: this.querySelector('.carousel-indicators'),
      dotsNode: null,
      autoplay: this.getAttribute('autoplay'),
      slideCenter: this.getAttribute('slide-center'),
      loop: this.getAttribute('loop'),
      autoplayDelay: this.getAttribute('autoplay-delay'),
      infinite: this.getAttribute('infinite')
    }
  }

  // 初始化配置项
  initOption() {
    this.autoplay = this.element.autoplay === 'true';
    this.slideCenter = this.element.slideCenter === 'true';
    this.loop = this.element.loop === 'true';
    this.autoplayDelay = this.element.autoplayDelay ? parseFloat(this.element.autoplayDelay) : 5000;
    this.infinite = this.element.infinite === 'true';
  }

  // 初始化轮播
  initCarousel() {
    this.resetTrackPosition(); // 初始化轨道位置
    this.bindAllEvents(); // 统一绑定所有事件

    if (this.isAutoplay) {
      this.bindAutoplay(); // 自动播放
    }

    this.isInitialized = true;
  }

  // 更新轮播
  updateCarousel() {
    this.isAnimate = true; // 开启动画锁
    this.resetTrackPosition();

    // 动画结束后处理循环，单次监听防止重复触发
    let speed = this.autoplayDelay;
    if (!this.infinite) {
      speed = this.speed;
      clearTimeout(this.loopTimer);
    }
    this.loopTimer = setTimeout(() => {
      clearTimeout(this.loopTimer);
      this.loopTimer = null;
      this.animationEndCallback();
    }, speed)
  }

  // 计算宽度
  calcWidth() {
    if (this.element.slidesNode) {
      this.slideOffsetWidths = this.element.slidesNode.scrollWidth;
      const computedBoxStyle = window.getComputedStyle(this.element.slidesNode);
      this.boxWidth = parseFloat(computedBoxStyle.width);
      this.gapWith = parseFloat(computedBoxStyle.gap) || 0;
    }
    if (this.element.slideItemNode && this.element.slideItemNode.length) {
      this.slideCount = this.element.slideItemNode && this.element.slideItemNode.length;
      const computedStyle = window.getComputedStyle(this.element.slideItemNode[0]);

      this.itemWidth = parseFloat(computedStyle.width);
      // 计算容器一屏可以展示的轮播项目数量
      this.itemCountPerRow = Math.floor(this.boxWidth / this.itemWidth);
      this.indicatorNum = this.slideCount - this.itemCountPerRow; // 是因为索引值是0开始
      if (this.indicatorNum <= this.startIndex) {
        this.indicatorNum = this.startIndex;
        this.isAutoplay = false;
      }

      // this.slideOffsetWidths = this.slideCount * this.itemWidth + this.gapWith * (this.slideCount - 1);
    }
  }

  // 重置轨道位置
  resetTrackPosition() {
    let speed = this.autoplayDelay;
    let currentIndex = this.currentIndex;
    if (this.currentIndex > this.indicatorNum) {
      currentIndex = this.indicatorNum;
    }
    let slidesOffsetX = (this.itemWidth + this.gapWith) * currentIndex;
    if (!this.infinite) {
      speed = this.speed;
      let maxMoveRange = this.slideOffsetWidths - this.boxWidth;
      if (this.slideOffsetWidths < this.boxWidth) maxMoveRange = 0; // 没有足够的宽度，不能滑动
      if (slidesOffsetX > maxMoveRange) {
        slidesOffsetX = maxMoveRange;
      }
    }

    this.startTimeInfinite = Date.now();

    this.currentMoveRange = slidesOffsetX;
    this.element.slidesNode.style.transition = `all ${speed / 1000}s linear`;
    this.element.slidesNode.style.transform = `translateX(${-slidesOffsetX}px)`;
    void this.element.slidesNode.offsetWidth; // 强制重绘，防止过渡失效
  }

  // 绑定所有事件
  bindAllEvents() {
    if (!this.infinite) {
      this.bindDragEvents();
    } else {
      this.bindMouseEvents();
    }

    window.merakiUtils.viewportResize.subscribe(() => {
      if (!this.infinite) {
        this.calcWidth();
        this.resetTrackPosition();
      } else {
        clearTimeout(this.loopTimer);
        this.loopTimer = null;

        this.element.slideItemNode = this.querySelectorAll('.l-carousel-slide');
        this.calcWidth();

        this.currentIndex = 0;
        let slidesOffsetX = 0;
        this.currentMoveRange = slidesOffsetX;
        this.element.slidesNode.style.transition = `all 0s linear`;
        this.element.slidesNode.style.transform = `translateX(${-slidesOffsetX}px)`;
        void this.element.slidesNode.offsetWidth; // 强制重绘，防止过渡失效
        this.startInterval();
      }
    });
  }

  // 不会自动走马灯，可以拖拽的事件
  bindDragEvents() {
    // 移动端滑动事件
    let startX = 0, moveX = 0, isMoving = false, startY = 0;
    this.element.slidesNode.addEventListener('touchstart', (e) => {
      if (this.isAnimate) return;
      isMoving = true;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    });

    this.element.slidesNode.addEventListener('touchmove', (e) => {
      if (!isMoving || this.isAnimate) return;
      moveX = e.touches[0].clientX - startX;
      const deltaY = e.touches[0].clientY - startY;
      if (Math.abs(moveX) > Math.abs(deltaY)) {
        this.element.slidesNode.style.transition = 'none';
        this.element.slidesNode.style.transform = `translateX(${-(this.currentMoveRange - moveX)}px)`;
        e.preventDefault();
      }
    }, { passive: false });

    this.element.slidesNode.addEventListener('touchend', () => {
      touchEndcallback.apply(this)
    });

    this.element.slidesNode.addEventListener('touchcancel', () => {
      touchEndcallback.apply(this)
    });

    // 手势滑动结束回调
    function touchEndcallback() {
      if (!isMoving || this.isAnimate) return;
      isMoving = false;
      const threshold = this.boxWidth * 0.2; // 滑动阈值
      const endIndex = this.indicatorNum; // 结束索引
      if (moveX > threshold) {
        if (this.loop || this.currentIndex !== this.startIndex) {
          if (this.currentIndex === this.startIndex) {
            this.currentIndex = endIndex;
          } else {
            this.currentIndex--;
          }
        }
      } else if (moveX < -threshold) {
        if (this.loop || this.currentIndex !== endIndex) {
          if (this.currentIndex === endIndex) {
            this.currentIndex = this.startIndex;
          } else {
            this.currentIndex++;
          }
        }
      };
      this.updateCarousel();
      startX = 0;
      moveX = 0;
    }

    if (this.dragMove && this.element.carouselContentNode) {
      let dragStartX = 0;
      let scrollLeftData = 0;
      let walk = 0;
      this.element.carouselContentNode.addEventListener('mousedown', (e) => {
        if (this.loop) {
          this.pauseInterval();
        }
        this.isDragging = true;
        dragStartX = e.pageX - this.element.carouselContentNode.offsetLeft;
        scrollLeftData = this.element.slidesNode.style.transform.replace('translateX(', '').replace('px)', '');
        const style = getComputedStyle(this.element.slidesNode);
        const matrix = new WebKitCSSMatrix(style.transform || style.webkitTransform);
        scrollLeftData = matrix.m41

      })
      this.element.carouselContentNode.addEventListener('mousemove', (e) => {
        if (!this.isDragging) return;
        const dragEndX = e.pageX;
        const x = dragEndX - this.element.carouselContentNode.offsetLeft;
        walk = (x - dragStartX) * 1.2;

        const moveItemX = scrollLeftData + walk;

        this.element.slidesNode.style.transition = `all 0s`;
        this.element.slidesNode.style.transform = `translateX(${moveItemX}px)`;
        void this.element.slidesNode.offsetWidth; // 强制重绘，防止过渡失效
      })
      this.element.carouselContentNode.addEventListener('mouseup', (e) => {
        if (this.isDragging) {
          this.isDragging = false;
          mouseleavecallback.apply(this);
          if (this.loop) {
            this.bindAutoplay();
          }
        }
      })
      this.element.carouselContentNode.addEventListener('mouseleave', (e) => {
        if (this.isDragging) {
          this.isDragging = false;
          mouseleavecallback.apply(this);
          if (this.loop) {
            this.bindAutoplay();
          }
        }
      })

      // 鼠标离开轮播图
      function mouseleavecallback() {
        const moveItemNum = Math.floor(Math.abs(walk) / this.itemWidth);
        if (walk > 0) {
          // 加：右滑
          let index = this.currentIndex - moveItemNum;
          if (index <= this.startIndex) {
            index = this.startIndex;
          }
          this.customSwitch(index);
        } else {
          // 减：左滑
          let index = this.currentIndex + moveItemNum;
          if (Math.abs(index) > this.indicatorNum) {
            index = this.indicatorNum;
          }
          this.customSwitch(index);
        }
      }
    }
  }

  // 自动走马灯，同时鼠标移入暂停，移除接着播放
  bindMouseEvents() {
    if (this.element.carouselContentNode) {
      let remainDur = this.autoplayDelay; // 单屏总时长ms
      let isPaused = false;
      let pass = 0;
      this.element.carouselContentNode.addEventListener('mouseenter', () => {
        if(isPaused) return;
        isPaused = true;
        clearTimeout(this.loopTimer);
        pass = Date.now() - this.startTimeInfinite;
        remainDur = this.autoplayDelay - pass;
        // 关键：获取当前位置，冻结动画
        const style = window.getComputedStyle(this.element.slidesNode);
        const matrix = new DOMMatrix(style.transform);
        const currentX = matrix.e; // 当前真实偏移量
        this.element.slidesNode.style.transition = 'none';
        this.element.slidesNode.style.transform = `translateX(${currentX}px)`;
      })
      this.element.carouselContentNode.addEventListener('mouseleave', () => {
        if(!isPaused) return;
        isPaused = false;
        this.startTimeInfinite = Date.now() - pass;
        this.element.slidesNode.style.transition = `all ${remainDur}ms linear`;
        this.element.slidesNode.style.transform = `translateX(${-this.currentMoveRange}px)`;

        this.loopTimer = setTimeout(() => {
          clearTimeout(this.loopTimer);
          this.loopTimer = null;
          this.animationEndCallback();
        }, remainDur)
      })
    }
  }

  // 轮播自动播放
  bindAutoplay() {
    if (!this.autoplayTimer && (this.autoplay || this.infinite)) {
      this.startInterval();
      if (!this.infinite) {
        this.autoplayTimer = setInterval(this.startInterval.bind(this), this.autoplayDelay);
      }
    }
  }

  // 启动自动轮播
  startInterval() {
    if (this.currentIndex === this.indicatorNum) {
      this.currentIndex = this.startIndex;
    } else {
      this.currentIndex++;
    }
    this.updateCarousel();

    if (!this.loop && this.currentIndex === this.indicatorNum) {
      this.pauseInterval();
    }
  }

  // 暂停自动轮播
  pauseInterval() {
    clearInterval(this.autoplayTimer);
    this.autoplayTimer = null;
  }

  // 轮播动画结束
  animationEndCallback() {
    this.isAnimate = false; // 关闭动画锁
    // 无缝轮播
    if (this.infinite && this.isAutoplay) {
      this.currentIndex = this.startIndex;
      this.moveFirstToLast();
      this.startInterval();
      return;
    }
  }

  // 自定义切换轮播项
  customSwitch(index) {
    if (this.isAnimate) return;
    this.currentIndex = parseFloat(index);
    if (this.isInitialized) {
      this.updateCarousel();
    } else {
      this.init();
      this.currentIndex = parseFloat(index);
      this.updateCarousel();
    }
  }

  // 将第一个轮播选项的 DOM 移动到最后，并删除第一个轮播选项节点
  moveFirstToLast() {
    if (this.element.slidesNode) {
      const itemsNode = this.element.slidesNode.querySelectorAll('.l-carousel-slide');
      const firstSlide = itemsNode[0];
      if (firstSlide) {
        this.element.slidesNode.appendChild(firstSlide.cloneNode(true));
        firstSlide.remove();
        this.element.slidesNode.style.transition = `all 0s`;
        this.element.slidesNode.style.transform = `translateX(0px)`;
        void this.element.slidesNode.offsetWidth; // 强制重绘，防止过渡失效
      }
    }
  }
}
customElements.define("mrk-carousel-drag", MrkCarouselDrag);

// 定义一个 对比表格 组件，设置高亮的的高度
class MrkCompareTable extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
    this.element = null;
    this.initHeight = false; // 是否初始化高度
  }
  connectedCallback() {
    // 使用全局的IntersectionObserver来进行懒加载初始化
    if (window.merakiUtils && window.merakiUtils.lazyObserver) {
      window.merakiUtils.lazyObserver.observe(this);
    } else {
      // 如果没有懒加载的IntersectionObserver直接初始化，避免组件用不了
      this.init();
    }
  }
  init() {
    this.element = this.getElements();

    this.initHeight = this.element.initHeight === 'true';

    if (this.initHeight) {
      this.setItemHeight();
    } else {
      this.setActiveHeight();
    }

    if (window.merakiUtils && window.merakiUtils.viewportResize) {
      window.merakiUtils.viewportResize.subscribe(() => {
        if (this.initHeight) {
          this.setItemHeight();
        } else {
          this.setActiveHeight();
        }
      });
    }
  }
  getElements() {
    return {
      thNodes: this.querySelectorAll('[table-th]'),
      thActiveNode: this.querySelector('[table-th].active'),
      tableBlockNode: this.querySelector('[table-block]'),
      initHeight: this.getAttribute('init-height'),
    }
  }
  setActiveHeight() {
    if (this.element.thActiveNode && this.element.tableBlockNode) {
      const blockHeight = this.getBoundingClientRect().height;
      this.element.thActiveNode.style.setProperty('--th-height', `${blockHeight}px`);
    }
  }
  setItemHeight() {
    if (this.element.thNodes && this.element.thNodes.length && this.element.tableBlockNode) {
      const blockHeight = this.getBoundingClientRect().height;
      this.element.thNodes.forEach(item => {
        item.style.setProperty('--th-height', `${blockHeight}px`);
      })
    }
  }
}
customElements.define("mrk-compare-table", MrkCompareTable);

class mrkStickyScrollAnimation extends HTMLElement {
  constructor() {
    super();

    this.isInitialized = false; // 是否初始化完成

    this.observer = null;  // 交叉观察器实例，用于后续销毁
    this.ratio = 0; // 当前组件距离可视窗口距离是可视窗口的0倍就开始初始化（进入就开始初始化）。

    this.sectionOffsetTop = 0; // 当前 DOM 距离文档顶部距离
    this.element = null;
    this.sectionCount = 0; // 当前组件有多个少个Section
    this.currentAnimationIndex = 0; // 当前正在动画的索引
    this.isAnimation = false; // 是否正在进行动画

    this.interactionType = null;
    this.lazyLoad = false;
    this.sectionTag = '[sticky-section]';
    this.scrollable = false; // 是否不开启滚动效果逻辑，默认开启
  }

  connectedCallback() {
    // 使用全局的IntersectionObserver来进行懒加载初始化
    if (window.merakiUtils && window.merakiUtils.lazyObserver) {
      window.merakiUtils.lazyObserver.observe(this);
    } else {
      // 如果没有懒加载的IntersectionObserver直接初始化，避免组件用不了
      this.init();
    }
  }
  init() {
    this.sectionOffsetTop = this.getOffsetTop(this);
    this.element = this.getElements();
    this.interactionType = this.getAttribute('interaction-type');
    this.lazyLoad = this.getAttribute('lazy') === 'true';
    this.scrollable = this.getAttribute('scrollable') === 'false';
    this.sectionCount = this.element.sectionsNode.length;

    if (this.sectionCount < 1) return;

    if (this.lazyLoad) {
      this.loadVisible();
    }

    const windowWidth = Math.max(
      document.documentElement.clientWidth,
      window.innerWidth || 0
    );

    this.switchTab();

    this.isAnimation = true;
    this.setItemContentHeight();
    if (windowWidth > 990 && !this.scrollable) {
      this.bindEvent();
    }
  }
  loadVisible() {
    // 加载媒体资源
    const mediaItemNodes = this.querySelectorAll('[mrk-product-image]');
    mediaItemNodes.forEach(item => {
      const tagName = item.tagName.toLowerCase();
      if (tagName === 'img') {
        if (window.getComputedStyle(item).display !== 'none') {
          window.merakiUtils.loadImage(item);
        }
      }
    })
  }
  getElements() {
    return {
      sectionsNode: this.querySelectorAll(this.sectionTag),
      tabItemNode: this.querySelectorAll('[tab-item]'),
      mediaItemNode: this.querySelectorAll('[media-item]')
    }
  }
  getViewInfo() {
    return {
      viewportHeight: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
      scrollTop: window.scrollY || document.documentElement.scrollTop
    }
  }
  getSectionHeight(sectionNode) {
    const sectionHeight = sectionNode.innerHeight || sectionNode.clientHeight || sectionNode.clientHeight;
    return sectionHeight;
  }
  // 获取当前DOM到文档顶部的距离
  getOffsetTop(element) {
    let top = 0;
    while (element) {
      top += element.offsetTop;
      element = element.offsetParent;
    }
    return top;
  }
  handleScroll() {
    if (!this.isAnimation) return;
    // 示例：获取页面滚动位置
    const viewInfo = this.getViewInfo();
    const scrollTop = viewInfo.scrollTop;
    if (this.element.sectionsNode && this.element.sectionsNode.length) {
      let extraHeight = 0;
      for (let i = 0; i < this.element.sectionsNode.length; i++) {
        const sectionNode = this.element.sectionsNode[i];
        const index = i;
        const sectionHeight = this.getSectionHeight(sectionNode);
        // const extraHeight = viewInfo.viewportHeight * index;

        // let sectionTop = index * viewInfo.viewportHeight + this.sectionOffsetTop;       // 这一屏开始位置
        // let sectionEnd = (index + 1) * viewInfo.viewportHeight + this.sectionOffsetTop; // 这一屏结束位置
        let sectionTop = extraHeight + this.sectionOffsetTop;       // 这一屏开始位置
        let sectionEnd = (extraHeight + sectionHeight) + this.sectionOffsetTop; // 这一屏结束位置

        // 多一个 section，因为滚动的效果是进入当前section才会开始滚动效果，滚动效果是当前可视窗口的高度
        sectionTop += extraHeight;
        sectionEnd += extraHeight;
        extraHeight += sectionHeight;

        // 只有当前屏完全进入视口后，才计算动画百分比
        if (scrollTop > sectionTop && scrollTop < sectionEnd) {
          this.currentAnimationIndex = index;
          // const progress = (scrollTop - sectionTop) / viewInfo.viewportHeight;
          const progress = (scrollTop - sectionTop) / sectionHeight;
          this.setAnimation(sectionNode, progress);
          break;
        } else if (scrollTop > sectionTop) {
          this.setAnimation(sectionNode, 1);
        } else {
          this.setAnimation(sectionNode, 0);
        }
      }
    }
  }
  bindEvent() {
    this.handleScroll();
    window.addEventListener('scroll', this.throttle(this.handleScroll.bind(this), 1));

    if (window.merakiUtils && window.merakiUtils.viewportResize) {
      window.merakiUtils.viewportResize.subscribe(() => this.handleScroll());
    }

    window.merakiUtils.viewportResize.subscribe(() => {
      this.sectionOffsetTop = this.getOffsetTop(this);
    });
  }
  setItemContentHeight() {
    this.element.tabItemNode.forEach((item) => {
      const contentNode = item.querySelector('[tab-item-content]');
      if (contentNode) {
        const height = contentNode.scrollHeight;
        contentNode.style.setProperty('--item-height', `${height}px`);
      }
    })
  }
  // 设置动画, 这个方法可以通过继承去修改，设置对应的效果
  setAnimation(sectionNode, progress = 0) {
    if (this.interactionType === 'imageTextAlign') {
      // sections\mrk-espresso-system.liquid 类型一
      const ratio = parseFloat(this.getAttribute('data-ratio')) || 70;
      let textRatio = 100 * progress * 2;
      if (textRatio > 100) {
        textRatio = 100;
      } else if (textRatio < 0) {
        textRatio = 0;
      }
      let newRatio = (100 - ratio) * progress * 2;
      if (newRatio > ratio) {
        newRatio = ratio;
      } else if (newRatio < 0) {
        newRatio = 0;
      }
      let progressRatio = ratio + newRatio;
      if (progressRatio > 100) progressRatio = 100;
      sectionNode.style.setProperty('--progress-ratio', `${progressRatio}%`);
      sectionNode.style.setProperty('--text-ratio', `${100 - textRatio}%`);
      return;
    }
    if (this.interactionType === 'stickyTabs') {
      // sections\mrk-everyday-use-cohesive.liquid 类型二
      const filterItemNodes = Array.from(this.element.tabItemNode).filter((item) => item.closest(this.sectionTag) === sectionNode);
      const filterMediaItemNodes = Array.from(this.element.mediaItemNode).filter((item) => item.closest(this.sectionTag) === sectionNode);

      const blockNum = parseFloat(this.getAttribute('data-block')) || 0;
      let index = this.getValueSegmentIndex(progress, blockNum);
      filterItemNodes.forEach((item, i) => {
        item.classList.remove('active');
        if (i === index) {
          item.classList.add('active');
        }
      })

      if (filterMediaItemNodes.length > 1 && index <= filterMediaItemNodes.length - 1) {
        filterMediaItemNodes.forEach((item, i) => {
          item.classList.remove('active');
          if (i === index) {
            item.classList.add('active');
          }
        })
      }
      return;
    }
  }
  switchTab() {
    this.setItemContentHeight();
    this.switchTabShow(0);
    // 这里还需要处理多个 sticky-section 的情况
    this.element.tabItemNode.forEach((item, i) => {
      item.addEventListener('click', (e) => {
        this.switchTabShow(i);

        const sectionNode = item.closest(this.sectionTag);
        const sectionHeight = sectionNode.clientHeight;

        const windowWidth = Math.max(
          document.documentElement.clientWidth,
          window.innerWidth || 0
        );
        if (windowWidth > 990 && !this.scrollable) {
          // 点击需要滚动到对应的位置
          // const viewInfo = this.getViewInfo();
          const tabNum = this.element.tabItemNode.length;
          const averageHeight = sectionHeight / tabNum;
          // const averageHeight = viewInfo.viewportHeight / tabNum;
          window.scrollTo({
            top: this.sectionOffsetTop + averageHeight * i + 10
          });
        }
      })
    })
  }
  switchTabShow(i) {
    this.element.tabItemNode.forEach((item, childI) => {
      item.classList.remove('active');
      if (childI === i) {
        item.classList.add('active');
      }
    })
    if (i > this.element.mediaItemNode.length - 1) return;
    this.element.mediaItemNode.forEach((item, childI) => {
      item.classList.remove('active');
      if (childI === i) {
        item.classList.add('active');
      }
    })
  }
  /**
   * 0-1 数值分段，返回所在区间索引
   * @param {number} value 0~1 之间的数值
   * @param {number} segment 分成几段
   * @returns {number} 区间索引
   */
  getValueSegmentIndex(value, segment = 3) {
    // 限制在 0~1 内
    const min = Math.min(1, value) === 1 ? 0.99 : value;
    const val = Math.max(0, min);
    // 每段宽度
    const step = 1 / segment;
    // 计算索引 向下取整
    const index = Math.floor(val / step);
    return index;
  }
  // 节流
  throttle(fn, delay = 100) {
    let timer = null; // 定时器标记
    let lastRunTime = 0; // 上一次执行时间
    return function (...args) {
      const now = Date.now();
      // 如果距离上次执行时间超过delay，立即执行
      if (now - lastRunTime > delay) {
        fn.apply(this, args);
        lastRunTime = now;
      } else {
        // 否则清除定时器，重新计时
        clearTimeout(timer);
        timer = setTimeout(() => {
          fn.apply(this, args);
          lastRunTime = Date.now();
        }, delay);
      }
    }
  }
}
customElements.define("mrk-sticky-scroll-animation", mrkStickyScrollAnimation);

// 定义一个自定义元素 <mrk-expandable> 来显示可展开的内容
class MrkExpandable extends HTMLElement {
  constructor() {
    super();

    this.element = null;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.element = this.getElements();

    this.eventBind();
  }

  getElements() {
    return {
      containerNode: this.querySelector('.product-expandable-block, [product-expandable-block]'),
      expandableTabNode: this.querySelector('.expandable-title, [expandable-title]')
    }
  }

  eventBind() {
    this.addEventListener('click', (e) => {
      const titleNode = e.target.closest('.expandable-title, [expandable-title]');
      if (titleNode) {
        const expandableBlockNode = titleNode.closest('.product-expandable-block, [product-expandable-block]');
        if (expandableBlockNode) {
          const isOpen = expandableBlockNode.getAttribute('open');
          if (isOpen !== null) {
            expandableBlockNode.removeAttribute('open');
          } else {
            expandableBlockNode.setAttribute('open', true)
          }
        }
      }

      // 是否有需要点击的按钮，比如发送邮件按钮
      const contactTtemBtnNode = e.target.closest('.contact-item--btn');
      if (contactTtemBtnNode) {
        const popupId = contactTtemBtnNode.dataset.popupId;
        if (popupId) {
          const popupNode = document.querySelector(`#${popupId}`);
          if (popupNode) {
            popupNode.open();
          }
        }
      }
    })
  }

  disconnectedCallback() {
  }
}
customElements.define("mrk-expandable", MrkExpandable);

/*
鼠标移入某个item，这个item添加active样式，其它添加no-active
移除active样式时，所有item都移除no-active样式
*/
class MrkItemHoverActive extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
    this.element = null;

  }
  connectedCallback() {
    // 使用全局的IntersectionObserver来进行懒加载初始化
    if (window.merakiUtils && window.merakiUtils.lazyObserver) {
      window.merakiUtils.lazyObserver.observe(this);
    } else {
      // 如果没有懒加载的IntersectionObserver直接初始化，避免组件用不了
      this.init();
    }
  }
  init() {
    this.element = this.getElements();
    this.bindEvent();
  }
  getElements() {
    return {
      itemNodes: this.querySelectorAll('[data-item]'),
      playBtnNodes: this.querySelectorAll('[data-play-btn]')
    }
  }
  bindEvent() {
    const windowWidth = Math.max(
      document.documentElement.clientWidth,
      window.innerWidth || 0
    );
    if (windowWidth > 990) {
      this.element.itemNodes.forEach((itemNode) => {
        itemNode.addEventListener('mouseenter', () => {
          this.element.itemNodes.forEach((item) => {
            const itemHeight = item.clientHeight;
            item.style.setProperty('--item-height', `${itemHeight}px`);
            item.classList.remove('active');
            item.classList.add('no-active');
            this.pauseVideo(item);
          })
          itemNode.classList.add('active');
          itemNode.classList.remove('no-active');
          this.playVideo(itemNode);
        })
      })
      this.addEventListener('mouseleave', () => {
        this.element.itemNodes.forEach((item) => {
          item.classList.remove('active');
          item.classList.remove('no-active');
        })
      })
    }

    this.addEventListener('click', (e) => {
      const playBtnNode = e.target.closest('[data-play-btn]');
      if (playBtnNode) {
        const itemNode = playBtnNode.closest('[data-item]');
        if (itemNode) {
          if (playBtnNode.classList.contains('play')) {
            // 点击已播放按钮，暂停视频
            this.pauseVideo(itemNode);
            playBtnNode.classList.remove('play');
            return;
          }
          // 暂停其他视频
          this.element.itemNodes.forEach((item) => {
            if (item !== itemNode) {
              this.pauseVideo(item);
              const palyBtn = item.querySelector('[data-play-btn]');
              palyBtn.classList.remove('play');
            } else {
              // 播放当前视频
              this.playVideo(itemNode);
              itemNode.classList.add('play');
              playBtnNode.classList.add('play');
            }
          })
        }
      }
    })
  }
  playVideo(itemNode) {
    const videoNode = itemNode.querySelector('video');
    if (!videoNode) return;
    if (videoNode.classList.contains('lazy-video-load')) {
      window.merakiUtils.loadVideo(videoNode);
      videoNode.classList.remove('lazy-video-load');
    }
    this.playVideoIfCan(videoNode);
  }
  playVideoIfCan(video) {
    // 已经可以直接播放
    if (video.readyState >= 3) {
      video.play();
      return;
    }
    // 等待可以播放再执行一次
    const onCanPlay = () => {
      video.play();
      video.removeEventListener('canplaythrough', onCanPlay);
    };
    video.addEventListener('canplaythrough', onCanPlay);
  }
  // 暂停视频
  pauseVideo(itemNode) {
    const videoNode = itemNode.querySelector('video');
    if (!videoNode) return;
    videoNode.pause();
  }
}
customElements.define("mrk-item-hover-active", MrkItemHoverActive);

// 定义一个 tab 切换组件（选项卡组件）
class MrkTabSwitch extends HTMLElement {
  constructor() {
    super();

    this.observer = null;
    this.element = null;

    this.activeClass = 'active';
    this.defaultTabIndex = 0;
  }

  connectedCallback() {
    // 使用全局的IntersectionObserver来进行懒加载初始化
    if (window.merakiUtils && window.merakiUtils.lazyObserver) {
      window.merakiUtils.lazyObserver.observe(this);
    } else {
      // 如果没有懒加载的IntersectionObserver直接初始化，避免组件用不了
      this.init();
    }
  }

  init() {
    this.element = this.getElements();
    this.setActiveTab(this.defaultTabIndex);
    this.bindEvent();
  }

  getElements() {
    return {
      tabContainerNode: this.querySelector('[tab-btn-container]'),
      tabBtnNodes: this.querySelectorAll('[tab-btn]'),
      tabContentNodes: this.querySelectorAll('[tab-content]')
    }
  }

  bindEvent() {
    this.element.tabBtnNodes.forEach((tabBtnNode, index) => {
      tabBtnNode.addEventListener('click', () => {
        this.setActiveTab(index);
      })
    })
  }

  setActiveTab(index) {
    this.element.tabBtnNodes.forEach((tabBtnNode) => {
      tabBtnNode.classList.remove(this.activeClass);
    })
    this.element.tabContentNodes.forEach((tabContentNode) => {
      tabContentNode.classList.remove(this.activeClass);
    })

    const tabBtnNode = this.element.tabBtnNodes[index];
    const tabContentNode = this.element.tabContentNodes[index];
    tabBtnNode.classList.add(this.activeClass);
    tabContentNode.classList.add(this.activeClass);

    this.scrollToLeft(index);
  }

  scrollToLeft(index) {
    const tabBtnNode = this.element.tabBtnNodes[index];
    const tabBtnWidth = tabBtnNode.offsetWidth;
    const tabBtnOffsetLeft = tabBtnNode.offsetLeft;
    const tabContainerWidth = this.element.tabContainerNode.offsetWidth;
    const targetScrollLeft = tabBtnOffsetLeft - (tabContainerWidth - tabBtnWidth) / 2;
    this.element.tabContainerNode.scrollTo({
      left: targetScrollLeft,
      behavior: 'smooth'
    })
  }
}
customElements.define("mrk-tab-switch", MrkTabSwitch);

// 定义一个自定义元素 <mrk-coupon-card> 来显示优惠券信息和倒计时
class MrkCouponCard extends HTMLElement {
  constructor() {
    super();

    this.observer = null;
    this.element = null;

    this.timer = null;
    this.endTime = null;
  }

  connectedCallback() {
    // 使用全局的IntersectionObserver来进行懒加载初始化
    if (window.merakiUtils && window.merakiUtils.lazyObserver) {
      window.merakiUtils.lazyObserver.observe(this);
    } else {
      // 如果没有懒加载的IntersectionObserver直接初始化，避免组件用不了
      this.init();
    }
  }

  init() {
    this.element = this.getElements();
    this.bindEvents();

    if (this.element.endTime) {
      const endTime = new Date(this.element.endTime);
      if (endTime && !isNaN(endTime.getTime())) this.endTime = endTime;
    }
    if (this.endTime) this.countdown();
  }

  bindEvents() {
    this.addEventListener('click', (e) => {
      const couponCardNode = e.target.closest('[coupon-card]');
      if (couponCardNode) {
        this.element.couponModalContentNode.style.display = '';
        document.body.style.overflow = 'hidden';
        return;
      }

      const couponModalCloseNode = e.target.closest('[coupon-modal-close]');
      const couponModalBoxNode = e.target.closest('[coupon-modal-box]');

      if (couponModalCloseNode) {
        this.element.couponModalContentNode.style.display = 'none';
        document.body.style.overflow = '';
      }
      if (couponModalBoxNode) return;
      if (e.target === this.element.couponModalContentNode) {
        this.element.couponModalContentNode.style.display = 'none';
        document.body.style.overflow = '';
      }
    });
  }

  getElements() {
    return {
      endTime: this.getAttribute('data-end-time'),
      hourNode: this.querySelector('.hour'),
      minuteNode: this.querySelector('.minute'),
      secondNode: this.querySelector('.second'),
      couponCardNode: this.querySelector('[coupon-card]'),
      couponModalContentNode: this.querySelector('[coupon-modal-content]')
    }
  }

  formatTime() {
    if (window.merakiUtils && window.merakiUtils.formatterTime) {
      const endTime = window.merakiUtils.formatterTime(this.endTime);
      const currentTime = window.merakiUtils.formatterTime(new Date());
      const timeDiff = new Date(endTime).getTime() - new Date(currentTime).getTime();
      if (timeDiff > 0) {
        if (window.merakiUtils && window.merakiUtils.useTimeRemaining) {
          const timeRemaining = window.merakiUtils.useTimeRemaining(timeDiff);

          this.renderNode(timeRemaining);
          return;
        }
      }
      this.renderNode({ hh: '00', mm: '00', ss: '00' });
      this.clearInterval();
    }
  }

  countdown() {
    this.formatTime();
    // 这里可以使用setInterval来进行倒计时更新
    this.timer = setInterval(() => {
      this.formatTime();
    }, 1000);
  }

  renderNode(timeRemaining) {
    if (this.element.hourNode) this.element.hourNode.textContent = timeRemaining.hh;
    if (this.element.minuteNode) this.element.minuteNode.textContent = timeRemaining.mm;
    if (this.element.secondNode) this.element.secondNode.textContent = timeRemaining.ss;
  }

  clearInterval() {
    clearInterval(this.timer);
    this.timer = null;
  }

  disconnectedCallback() {
    this.clearInterval();
  }
}
customElements.define("mrk-coupon-card", MrkCouponCard);